webpackJsonp([1],{

/***/ "+fnE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5UXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aCn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7bK5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cu10":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J4AD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NGGB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ddc7ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Om6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2c09f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("nSix")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-1d2c09f7"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f86d1c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("7bK5")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-9f86d1c4"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2f03a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("5UXz")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdf4d00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("5aCn")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20cacc42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("Cu10")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45475472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("HXhP")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-741fd409","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("NGGB")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d3493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("hxKv")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dfdf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("hLNX")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a0b1688","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("J4AD")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e710b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("o4GY")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4e710b5e"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399a74da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("hIWI")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d498b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("WpSr")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c24155a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("+fnE")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/document.js


var _ref;

/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Trafigura Foundation Annual Report 2023",
  "shortTitle": "",
  "description": "",
  "width": 692,
  "height": 901,
  "currentLanguage": "EN",
  "languages": [],
  // "basePath": "",
  "basePath": "/2023",
  "companyLogo": "logo.png",
  "publishURL": "http://touchline-trafigura.s3-website.eu-west-2.amazonaws.com/2023/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/2023/static/_content/trafigura-foundation-annual-report-2023.pdf',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 1-title\" style=\"top: 725px;left:64px;\" src=\"/2023/static/_content/1-title-1.png\" />\n        <img class=\"abs halfScaleC 1-logo\" style=\"top:20px;left:-16px;\" src=\"/2023/static/_content/1-logo-1.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim\n            .fromTo(cOf(\"1-logo\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n            .fromTo(cOf(\"1-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          resetNumbers(\"1-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "Annual Report  2023"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"2-no\" class=\"abs euclid-med 2-no\" style=\"top: 235px; left: 49px; font-size: 1.25em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 10, \"append\": \" million\", \"preppend\": \"USD\"}' ></h1>\n\n        <h1 id=\"2-no\" class=\"abs euclid-med 2-no\" style=\"top: 363px; left: 49px; font-size: 1.25em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 260000, \"preppend\": \"+\", \"comma\": true}' ></h1>\n        <h1 id=\"2-no\" class=\"abs euclid-med 2-no\" style=\"top: 363px; left: 246px; font-size: 1.25em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 43}' ></h1>\n        <h1 id=\"2-no\" class=\"abs euclid-med 2-no\" style=\"top: 363px; left: 444px; font-size: 1.25em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 22}' ></h1>\n\n        <h1 id=\"2-no\" class=\"abs euclid-med 2-no\" style=\"top: 491px; left: 49px; font-size: 1.25em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2, \"preppend\": \"USD\", \"append\": \" million\"}' ></h1>\n        <h1 id=\"2-no\" class=\"abs euclid-med 2-no\" style=\"top: 491px; left: 246px; font-size: 1.25em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 630000, \"preppend\":\"USD\", \"comma\": true}' ></h1>\n\n        <h1 id=\"2-no\" class=\"abs euclid-med 2-no\" style=\"top: 619px; left: 48px; font-size: 1.25em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 39}' ></h1>\n        <h1 id=\"2-no\" class=\"abs euclid-med 2-no\" style=\"top: 619px; left: 246px; font-size: 1.25em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 11}' ></h1>\n        <h1 id=\"2-no\" class=\"abs euclid-med 2-no\" style=\"top: 619px; left: 443px; font-size: 1.25em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 872000, \"preppend\": \"USD\", \"comma\": true}' ></h1>\n\n        <h1 id=\"2-no\" class=\"abs euclid-med 2-no\" style=\"top: 748px; left: 49px; font-size: 1.25em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 90, \"preppend\":\"USD\", \"append\": \" million\"}' ></h1>\n        <h1 id=\"2-no\" class=\"abs euclid-med 2-no\" style=\"top: 748px; left: 246px; font-size: 1.25em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 11, \"preppend\":\"USD\", \"append\": \" million\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax();\n          pg2Anim\n            .fromTo(cOf(\"2-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"2-no\")[0])}}, 1)\n            .fromTo(cOf(\"2-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"2-no\")[1])}}, 1.3)\n            .fromTo(cOf(\"2-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"2-no\")[2])}}, 1.4)\n            .fromTo(cOf(\"2-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"2-no\")[3])}}, 1.5)\n            .fromTo(cOf(\"2-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"2-no\")[4])}}, 1.6)\n            .fromTo(cOf(\"2-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"2-no\")[5])}}, 1.7)\n            .fromTo(cOf(\"2-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"2-no\")[6])}}, 1.8)\n            .fromTo(cOf(\"2-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"2-no\")[7])}}, 1.9)\n            .fromTo(cOf(\"2-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"2-no\")[8])}}, 2)\n            .fromTo(cOf(\"2-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"2-no\")[9])}}, 2.1)\n            .fromTo(cOf(\"2-no\")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"2-no\")[10])}}, 2.2)\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n          resetNumbers(\"2-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "2023 Key Figures  USD10 million Philanthropic budget  +260,000  43  22  people benefitting from our partnerships  multi-year programmes implemented  non-profit partners operating in 27 countries, mainly low- and middle-income countries across Africa, Asia, and Latin America  USD2 million  USD630,000  provided to a United Nations-led operation to prevent a catastrophic oil spill in the Red Sea  donated to respond to disasters globally  39  11  USD872,000  staff-led initiatives across Trafigura offices globally  Charity Committees, the employees' volunteering groups  disbursed to support local charitable projects selected by Trafigura staff  USD90 million  USD11 million  invested in philanthropic partnerships since the inception of the Trafigura Foundation in 2007  for 9 new climate adaptationfocused partnerships approved in 2023, with programmes to be implemented over the next three years"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n      <div class=\"contentLink\" style=\"top: 422px; left: 62px; width: 241px; height: 25px;\" onclick=\"Publish.goToPage(8)\"></div>\n      <div class=\"contentLink\" style=\"top: 449px; left: 62px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(9)\"></div>\n      <div class=\"contentLink\" style=\"top: 466px; left: 62px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(10)\"></div>\n      <div class=\"contentLink\" style=\"top: 482px; left: 62px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(11)\"></div>\n\n      <div class=\"contentLink\" style=\"top: 549px; left: 62px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(14)\"></div>\n      <div class=\"contentLink\" style=\"top: 566px; left: 62px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(16)\"></div>\n      <div class=\"contentLink\" style=\"top: 582px; left: 62px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(18)\"></div>\n      <div class=\"contentLink\" style=\"top: 599px; left: 62px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(20)\"></div>\n      <div class=\"contentLink\" style=\"top: 615px; left: 62px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(22)\"></div>\n      <div class=\"contentLink\" style=\"top: 631px; left: 62px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(24)\"></div>\n\n      <div class=\"contentLink\" style=\"top: 398px; left: 309px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(28)\"></div>\n      <div class=\"contentLink\" style=\"top: 415px; left: 309px; width: 241px; height: 24px;\" onclick=\"Publish.goToPage(29)\"></div>\n      <div class=\"contentLink\" style=\"top: 443px; left: 309px; width: 241px; height: 24px;\" onclick=\"Publish.goToPage(30)\"></div>\n      <div class=\"contentLink\" style=\"top: 471px; left: 309px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(31)\"></div>\n      <div class=\"contentLink\" style=\"top: 488px; left: 309px; width: 241px; height: 24px;\" onclick=\"Publish.goToPage(32)\"></div>\n      <div class=\"contentLink\" style=\"top: 515px; left: 309px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(33)\"></div>\n      <div class=\"contentLink\" style=\"top: 532px; left: 309px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(34)\"></div>\n      <div class=\"contentLink\" style=\"top: 548px; left: 309px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(35)\"></div>\n      <div class=\"contentLink\" style=\"top: 564px; left: 309px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(36)\"></div>\n      <div class=\"contentLink\" style=\"top: 581px; left: 309px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(37)\"></div>\n      <div class=\"contentLink\" style=\"top: 597px; left: 309px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(38)\"></div>\n      <div class=\"contentLink\" style=\"top: 613px; left: 309px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(40)\"></div>\n      <div class=\"contentLink\" style=\"top: 631px; left: 309px; width: 241px; height: 24px;\" onclick=\"Publish.goToPage(41)\"></div>\n      <div class=\"contentLink\" style=\"top: 658px; left: 309px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(42)\"></div>\n      <div class=\"contentLink\" style=\"top: 674px; left: 309px; width: 241px; height: 14px;\" onclick=\"Publish.goToPage(43)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Table of Contents Foreword: Messages from the Chairman and Executive Director Centring our funding on climate adaptation 06 Our rationale: responding to a burning imperative 07 Vision and mission 08 Our 2023-2027 strategy at a glance 09 Our approach, Our principles  Climate adaptation: Building the resilience of communities and ecosystems most vulnerable to climate change  Economic opportunities: Enable sustainable livelihoods as the backbone of thriving communities 26 Fundación Don Bosco 27 Association for the Advancement of Mexican Americans, AAMA 28 Research for Education and Career Help Institute, REACH 29 Education for Employment, EFE-Egypt 30 Association pour le droit à l’initiative économique, Adie 31 Germinal 32 Word of Mouth  12 Plan Vivo Foundation  33 Rede Asta  14 The Nature Conservancy  34 Solidaridad Internacional Kanda, SiKanda  16 Planet Indonesia  35 Fondation Energies pour le Monde, Fondem  18 Root Capital  36 Bridges to Prosperity  20 BOMA  38 Alliance for Responsible Mining, ARM  22 Conexsus, Institute of Sustainable Connections  39 International Seafarers´Welfare and Assistance Network, ISWAN 40 Smart Freight Centre 41 The International Rescue Committee, IRC  Disaster prevention and response Staff engagement: Beyond the workplace, employees united to support the greater good"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 4-title\" style=\"top: 62px;left:98px;\" src=\"/2023/static/_content/4-title-1.png\" />\n        <img class=\"abs halfScale 4-text\" style=\"top: 246px;left:157px;\" src=\"/2023/static/_content/4-text-1.png\" />\n        <img class=\"abs halfScaleC 4-img\" style=\"top:128px;left:-6px;\" src=\"/2023/static/_content/4-img-1.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim\n            .fromTo(cOf(\"4-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"4-img\"), 1, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.3)\n            .fromTo(cOf(\"4-text\"), 1, {opacity:0, x: -50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.8)\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          resetNumbers(\"4-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "2  	  A message from the Chairman  Andrew Vickerman As we reflect on our achievements over the past year, I am pleased to introduce the 2023 Annual Report of the Trafigura Foundation. Our commitment to making meaningful change remains steadfast as we confront the pressing challenges of our time.  In this spirit, we have embraced the imperative of climate adaptation, which entails adjusting to the present and future effects of climate change. We acknowledge the paramount importance of climate adaptation in confronting the social, economic, and environmental challenges that lie ahead, particularly those impacting the people and natural environments already facing the greatest effects of a changing climate. To tackle these issues, we firmly believe that true progress requires the bold ambitions and innovative solutions set out in our 2023-2027 strategy. This redefined approach to sustainability complements Trafigura’s corporate initiatives and investments, which aim to facilitate the energy transition to a lower-carbon world. By using a nuanced approach that incorporates both climate mitigation and adaptation strategies, we aim to bring about systemic change across various sectors.  As a corporate foundation, we also recognise the profound social dimension of our role. We embrace the opportunity to drive positive change by fostering philanthropy among Trafigura employees worldwide, and supporting the charitable activities they organise within their offices to benefit local communities. In line with its unwavering commitment to driving positive change, Trafigura has substantially increased the Foundation’s philanthropic budget to USD15 million in 2024, with further projected increases by 2027. As we embark on the journey ahead, I would like to thank everyone who has contributed to the success of the Trafigura Foundation. Together, we look forward to making a sustainable contribution to more resilience, equity, and opportunity for all."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 5-title\" style=\"top: 62px;left:113px;\" src=\"/2023/static/_content/5-title-1.png\" />\n        <img class=\"abs halfScale 5-text\" style=\"top: 246px;left:177px;\" src=\"/2023/static/_content/5-text-1.png\" />\n        <img class=\"abs halfScaleC 5-img\" style=\"top:135px;left:10px;\" src=\"/2023/static/_content/5-img-1.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax();\n          pg5Anim\n            .fromTo(cOf(\"5-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n            .fromTo(cOf(\"5-img\"), 1, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.5)\n            .fromTo(cOf(\"5-text\"), 1, {opacity:0, x: -50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2)\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop();\n          resetNumbers(\"5-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "  3  A message from the Executive Director  Dario Soto-Abril This year's Annual Report marks a new phase in Trafigura Foundation's journey, coinciding with a crucial decade for the planet.  In 2023, the world experienced climate-induced events including major floods, tropical cyclones, extreme heat and drought, and associated wildfires, affecting regions from Madagascar to the Bay of Bengal and resulting in heavy loss of life and destruction. As we underwent the hottest year on record since reliable climate data has been collected, climate-related hazards also worsened the flaws of our social and economic systems, exacerbating food and water insecurity and prompting many vulnerable populations, already affected by war and poverty, to flee their home countries. Some 3.6 billion people live in areas exposed to high climate risks, with the costs of adapting to them projected to exceed USD340 billion annually. Yet current climate funding does not even reach a tenth of that. Without increased funding, climate risks may lead to humanitarian, economic, health, and security crises that surpass our capacity. Building upon 15 years of the Trafigura Foundation’s history, we are now focusing our investments and expertise on catalytic solutions that contribute to building the resilience of communities and nature on the frontline of climate hazards. We commit to addressing the most pressing climate challenges by channelling resources into climate adaptation initiatives.  Recognising our potential role in driving change and influencing others, we strategically expanded our partnerships on topics ranging from regenerative agriculture to disaster risk insurance and the protection of coral reefs, among others. We also provided funding for humanitarian response to hurricanes, floods, and earthquakes by supporting projects that address the immediate needs of affected communities while considering their long-term recovery and resilience-building. Moving forward, we remain committed to making a positive impact on vulnerable communities through practical solutions, strategic partnerships, and responsible financial stewardship, all in the context of climate adaptation and resilience. We thank partners, peers, and all at Trafigura for their continued commitment to working together towards this ambitious mission."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 6-title\" style=\"top: 113px;left:50px;\" src=\"/2023/static/_content/6-title-1.png\" />\n\n        <h1 id=\"6-no\" class=\"abs euclid-reg 6-no\" style=\"top: 544px; left: 98px; font-size: 1.4em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 3.6, \"decimals\": 1}' ></h1>\n        <h1 id=\"6-no\" class=\"abs euclid-reg 6-no\" style=\"top: 603px; left: 100px; font-size: 1.4em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 130}' ></h1>\n        <h1 id=\"6-no\" class=\"abs euclid-reg 6-no\" style=\"top: 661px; left: 100px; font-size: 1.4em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 140, \"preppend\": \"USD\"}' ></h1>\n        <h1 id=\"6-no\" class=\"abs euclid-reg 6-no\" style=\"top: 661px; left: 182px; font-size: 1.4em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 300, \"preppend\": \"-\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim\n            .fromTo(cOf(\"6-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"6-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"6-no\")[0])}}, 1.3)\n            .fromTo(cOf(\"6-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"6-no\")[1])}}, 1.4)\n            .fromTo(cOf(\"6-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"6-no\")[2])}}, 1.5)\n            .fromTo(cOf(\"6-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"6-no\")[3])}}, 1.5)\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n          resetNumbers(\"6-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "4 Our hero partners  Centring our funding Quam quunt as on climate erion et antadaptation volectur, saername quatur aperferchil in nest utatius. In 2023, we initiated the rollout of a new strategy focusing on climate adaptation, which will guide our actions until 2027.  Climate change exacerbates existing inequalities and disproportionately impacts the most vulnerable. It disrupts global supply chains, affecting the flow of goods and services necessary for individuals to thrive.  The growing understanding of these issues has informed our decision to focus on programmes that contribute to helping communities and nature better adapt to the effects of climate change through flexible and Onsedicia quam dolorumet ulla dolo responsive solutions. molorum sit eatiur? Igenis nonsenim inctia nesequamus quatentur, idel magnate mquossites everum doluptatio conectis quos sundige nihitatem faccum sectisqui doluptaque vellor aut officae volum qui blatus dolest laccus enit endam et est, sapicil itioresto dolestruptas erfersp Global context ercienis sunt velitia is aut deliquat rerum aut ducium volupti res sequi ilitassi dolor re ma pedi volorro mint.  3.6 billion  people living in high climate risk areas  130 million  Genecuptat rem naturem illab inciendis dolorrum a dolecab iumquasim quossitis iuntotaque ne as asped ma pereprorepe labori ute por re accatusdant acerumet etur?  people may be pushed into poverty by climate change over the next 10 years  Ratiatus aut volore volestiat atem. Odis dolestiis restio. Nam commod quidebit occus volecto elenis pariatur, billion to consequatur sim intio. Itatemqui annual adaptation costs in developing countries by 2030 cuptatempos dolupis audantur sande omnis illam excerit ut atquid ut esequam quam eaquam aut aditiberum facea iumqui velloribus resciendest eos renduntiis iliat ipid quiam nobitat iistor Image caption can reperora in nimus.  USD140-300  go here"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Trafigura Foundation Annual Report 2023  5"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 8-title\" style=\"top: 64px;left:99px;\" src=\"/2023/static/_content/8-title-1.png\" />\n        <img class=\"abs halfScale 8-title\" style=\"top: 161px;left:99px;\" src=\"/2023/static/_content/8-title-2.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim\n            .staggerFromTo(cOf(\"8-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n          resetNumbers(\"8-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "6  Centring our funding on climate adaptation  Responding to a burning imperative  Our rationale Increased awareness  Fostering global cooperation  Climate change is a systemic risk that can no longer be ignored. Public, political, and corporate awareness has significantly increased due to extreme weather events and scientific advocacy, leading to commitments to reduce emissions and adapt to climate impacts.  We support international efforts, coalitions and agreements aimed at fostering global cooperation on climate change adaptation.  Mainstreaming climate into development Countries and organisations are embedding climate adaptation into development planning, aligning with broader goals. We have thus placed climate adaptation at the heart of our philanthropic efforts.  Availability of tested and new adaptation solutions Entities worldwide are leveraging technology, naturebased approaches, and community engagement to pioneer adaptation solutions. We scout these out and invest in the most promising initiatives aligned with our goals.  Bridging the adaptation finance gap Current international public finance flows cover only 10 percent of the adaptation costs that would be needed in low-income countries during this decade."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 9-title\" style=\"top: 250px;left:64px;\" src=\"/2023/static/_content/9-title-1.png\" />\n        <img class=\"abs halfScale 9-title\" style=\"top: 499px;left:64px;\" src=\"/2023/static/_content/9-title-2.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n          pg9Anim\n            .staggerFromTo(cOf(\"9-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1.15)\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop();\n          resetNumbers(\"9-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "7  Our vision  A world where individuals thrive and communities prosper in harmony with nature.  Our mission  To invest in catalytic solutions for resilient communities and ecosystems."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 10-title\" style=\"top: 161px;left:99px;\" src=\"/2023/static/_content/10-title-1.png\" />\n        <img class=\"abs halfScaleC 10-circle\" style=\"top:296px;left:150px;\" src=\"/2023/static/_content/10-circle-1.png\" />\n        <img class=\"abs halfScaleC 10-circle\" style=\"top:449px;left:60px;\" src=\"/2023/static/_content/10-circle-2.png\" />\n        <img class=\"abs halfScaleC 10-circle\" style=\"top:450px;left:243px;\" src=\"/2023/static/_content/10-circle-3.png\" />\n        <img class=\"abs halfScaleC 10-circle\" style=\"top:499px;left:260px;\" src=\"/2023/static/_content/10-circle-4.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n          pg10Anim\n            .fromTo(cOf(\"10-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .staggerFromTo(cOf(\"10-circle\"), 1, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.3)\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop();\n          resetNumbers(\"10-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "8  Centring our funding on climate adaptation  Our 2023-2027 strategy at a glance We have developed a comprehensive framework centred around the themes of prepared communities, thriving nature, and sustainable livelihoods. This framework helps us strategically address the complex and interconnected challenges of climate change adaptation, nature conservation, poverty reduction, and sustainable development.  Creating synergies across sectors can boost income generation, natural resource management, and community resilience to climate change. Empowering communities in decision-making and resource management enhances social cohesion, reduces inequalities, and fosters adaptive governance. That is why our new strategy addresses the interconnected challenges of climate change, ecosystem degradation, and poverty in an integrated, systemic and holistic manner.  We prioritise inclusive economic opportunities resilient to climate change. Our support includes sustainable agriculture, ﬁsheries, renewable energy, and green entrepreneurship, aiming to reduce poverty, enhance food security, and build resilient livelihoods for vulnerable communities.  Resilient communities and ecosystems Diverse ecosystems are crucial for human well-being, offering clean air, water, fertile soil, and ﬂood regulation. Conservation and restoration of natural habitats through sustainable land and water management enhance both human and environmental resilience, promoting climate adaptation.  By building their resilience, local communities enhance their capacity to anticipate, withstand, and recover from the impacts of climate change and other hazards."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 11-title\" style=\"top: 161px;left:65px;\" src=\"/2023/static/_content/11-title-1.png\" />\n        <img class=\"abs halfScale 11-title\" style=\"top: 557px;left:65px;\" src=\"/2023/static/_content/11-title-2.png\" />\n\n        <a class=\"addContentLink\" style=\"top: 391px;left: 368px;width: 74px;height: 18px;\" href=\"https://trafigurafoundation.org/news/trafigura-foundation-signs-a-call-to-action-to-accelerate-action-on-climate-adaptation/\" target=\"_blank\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax();\n          pg11Anim\n            .staggerFromTo(cOf(\"11-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1.15)\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop();\n          resetNumbers(\"11-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "Trafigura Foundation Annual Report 2023  9  Our approach Collective action Our strategy puts collective action at the centre of all adaptation efforts. We collaborate with diverse stakeholders, including philanthropists, development agencies, multilateral organisations, investors, academia, and donors. Our aim is to enhance ongoing efforts in climate adaptation by leveraging funds and attracting expertise.  Long-term commitment We partner for the long run. Our partnership cycles span several years. We invest in organisations and coalitions that set ambitious goals, supporting their initiatives from inception to maturity.  Joining forces to amplify impact As a funder, the Trafigura Foundation sees coalitions as a premier platform to increase learning, coordinate approaches, and align with other philanthropies to address the impacts of climate change at a large scale. In 2023, we signed a call to action with seventeen leading funders to catalyse efforts on climate adaptation initiatives and foster global resilience. Learn more ↗  Complementarity strategy To address the global adaptation financing gap, our climate adaptation work intends to complement the broader efforts of the philanthropic community, where climate efforts and investments are primarily centred on mitigation.  Our principles Grant-making process  Independence  The Trafigura Foundation does not accept unsolicited funding applications. Its Management Team proactively sources new non-profit partners based on the Foundation’s strategic priorities and the impact potential and quality of the partners’ programmes.  The Trafigura Foundation was created in 2007 by Trafigura as an independently managed, companyfunded philanthropic foundation. It operates as a charity under Swiss law. While the philanthropic achievements of the Foundation are part of the Group’s efforts toward greater sustainability and responsibility, the Foundation’s governance structure ensures funding decisions are independent of any business influence and guided by genuine philanthropic motivations.  The Management Team reaches out to potential partners, and jointly develops a project proposal for submission. The Foundation Board makes the final funding decision, based on the relevance of the proposed programme with respect to the Foundation’s mission, and its efficiency and impact."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 12-title\" style=\"top: 113px;left:50px;\" src=\"/2023/static/_content/12-title-1.png\" />\n        <img class=\"abs halfScale 12-title\" style=\"top: 181px;left:49px;\" src=\"/2023/static/_content/12-text-1.png\" />\n        <img class=\"abs halfScale 12-quote\" style=\"top: 639px;left:84px;\" src=\"/2023/static/_content/12-quote-1.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim\n            .staggerFromTo(cOf(\"12-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"12-quote\"), 1, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          resetNumbers(\"12-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "10  Climate adaptation Building the resilience of communities and ecosystems most vulnerable to climate change The first six non-profit partners presented in this year's report exemplify our new funding strategy, focused on building the resilience of the communities and ecosystems of low- and middle-income countries in Africa, Asia and Latin America that are most vulnerable to climate change. Healthy ecosystems are the basis of human well-being. Our investments contribute to making livelihoods more sustainable, helping people to earn a decent living while restoring and conserving nature. The programmes we fund support smallholder farmers, regenerative agriculture, ecosystem management and sustainable business practices. We also support programmes that help communities prepare to face and recover from multiplying disasters. These interconnected climate adaptation efforts contribute to outcomes that cannot be tackled in isolation from each other.  Voices of Partners  Rural communities that are most vulnerable to climate impacts are often the most innovative and driven to find climate solutions. Elizabeth Teague, Senior Director, Climate Resilience, at Root Capital"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Trafigura Foundation Annual Report 2023  11"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 14-title\" style=\"top: 62px;left:97px;\" src=\"/2023/static/_content/14-title-1.png\" />\n        <img class=\"abs halfScale 14-title\" style=\"top: 161px;left:100px;\" src=\"/2023/static/_content/14-title-2.png\" />\n\n        <h1 id=\"14-no\" class=\"abs euclid-med 14-no\" style=\"top: 600px; left: 588px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 28}' ></h1>\n        <h1 id=\"14-no\" class=\"abs euclid-med 14-no\" style=\"top: 640px; left: 406px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 164000, \"comma\": true}' ></h1>\n        <h1 id=\"14-no\" class=\"abs euclid-med 14-no\" style=\"top: 776px; left: 331px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 285000, \"comma\": true}' ></h1>\n\n        <a class=\"addContentLink\" style=\"top: 678px;left: 95px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/plan-vivo-foundation-2/\" target=\"_blank\"></a>\n        <a class=\"addContentLink\" style=\"top: 324px;left: 507px;width: 58px;height: 12px;\" href=\"https://www.planvivo.org/pv-nature-documentation\" target=\"_blank\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim\n            .staggerFromTo(cOf(\"14-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"14-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"14-no\")[0])}}, 1.4)\n            .fromTo(cOf(\"14-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"14-no\")[1])}}, 1.5)\n            .fromTo(cOf(\"14-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"14-no\")[2])}}, 1.6)\n            setTimeout(function(){\n              addContentLinks();\n            }, 2000);\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop();\n          resetNumbers(\"14-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "12  Climate adaptation: Building the resilience of communities and ecosystems most vulnerable to climate change  Access to the voluntary carbon market for smallholders  Plan Vivo Foundation Where Global (Latin America, Asia, the Pacific and Africa)  People we support Climate-vulnerable smallholder farmers and rural communities  The challenge We need to attract more nature-based investments for climate vulnerable communities in support of sustainable land management and poverty reduction. There is high demand for high-integrity, communityfocused carbon credits and other nature-based finance mechanisms that have positive effects on people, nature, and climate, but there are many barriers to new projects.  The solution The unique Plan Vivo model ensures that at least 60 percent of the revenue generated from the sale of Plan Vivo Certificates goes back to communities on the ground. This has a significant impact on strengthening resilience for vulnerable communities as well as reducing drivers of deforestation, environmental degradation, and biodiversity loss. Through this pilot phase of our partnership, the Trafigura Foundation supported Plan Vivo in establishing a Project Incubator Hub that helps nascent projects prepare for carbon certification, and to make sure regional validation and verification services are available in Africa, Asia and Latin America to help build a project pipeline of community-based natural climate solution projects. Find out more ↗  Overall impact of Plan Vivo  Last year, in collaboration with a number of strategic partners including Pivotal Earth, Fauna & Flora International and Carbon Tanzania, Plan Vivo developed the first biodiversity standard, PV Nature ↗, which is now open to new applications for projects with holistic impact on nature, climate and communities.  Partnership figures  41  people attended Project Incubator training  28  164,000 people involved in projects  285,000 hectares of land under sustainable management  certified projects in 21 countries since inception"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"15-no\" class=\"abs euclid-med 15-no\" style=\"top: 95px; left: 406px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 8.7, \"preppend\": \"+\", \"decimals\": 1}' ></h1>\n        <h1 id=\"15-no\" class=\"abs euclid-med 15-no\" style=\"top: 199px; left: 526px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 34, \"preppend\": \"USD\" }' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim\n            .fromTo(cOf(\"15-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"15-no\")[0])}}, 1)\n            .fromTo(cOf(\"15-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"15-no\")[1])}}, 1.1)\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop();\n          resetNumbers(\"15-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "13  As of 2023, the Trees for Global Benefits (TGB) project, in Uganda, has generated more than 3.8 million Plan Vivo Certificates, making it the largest Plan Vivo certified project.  +8.7 million  tonnes of CO2 in planned emission reductions  USD34 million in income to communities from the sale of Plan Vivo Certificates"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "14  Aerial image of Loango National Park in Gabon. The park consists of rainforest, savanna grasslands, lagoon and ocean."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 17-title\" style=\"top: 62px;left:65px;\" src=\"/2023/static/_content/17-title-1.png\" />\n        <img class=\"abs halfScale 17-title\" style=\"top: 161px;left:65px;\" src=\"/2023/static/_content/17-title-2.png\" />\n\n        <h1 id=\"17-no\" class=\"abs euclid-med 17-no\" style=\"top: 562px; left: 361px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 21}' ></h1>\n\n        <h1 id=\"17-no\" class=\"abs euclid-med 17-no\" style=\"top: 698px; left: 534px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 20}' ></h1>\n        <h1 id=\"17-no\" class=\"abs euclid-med 17-no\" style=\"top: 787px; left: 374px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 10}' ></h1>\n        <h1 id=\"17-no\" class=\"abs euclid-med 17-no\" style=\"top: 774px; left: 113px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 500000, \"comma\": true}' ></h1>\n\n        <a class=\"addContentLink\" style=\"top: 676px;left: 61px;width: 81px;height: 18px;\" href=\"https://www.trafigurafoundation.org/programmes/the-nature-conservancy-2/\" target=\"_blank\"></a>\n        <a class=\"addContentLink\" style=\"top: 503px;left: 87px;width: 213px;height: 12px;\" href=\"https://www.nature.org/en-us/about-us/where-we-work/africa/forest-carbon-catalyst/\" target=\"_blank\"></a>\n        <a class=\"addContentLink\" style=\"top: 259px;left: 372px;width: 119px;height: 12px;\" href=\"https://oneacrefund.org/\" target=\"_blank\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax();\n          pg17Anim\n            .staggerFromTo(cOf(\"17-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"17-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[0])}}, 1.4)\n            .fromTo(cOf(\"17-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[1])}}, 1.5)\n            .fromTo(cOf(\"17-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[2])}}, 1.6)\n            .fromTo(cOf(\"17-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[3])}}, 1.7)\n            setTimeout(function(){\n              addContentLinks();\n            }, 2500)\n        }\n\n        function onPageLeave() {\n          pg17Anim.stop();\n          resetNumbers(\"17-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "Trafigura Foundation Annual Report 2023  15  High-quality carbon projects for people and nature  The Nature Conservancy Where Republic of Congo and Zambia  People we support Smallholder farmers and forest-adjacent communities, as well as social enterprises and non-profit organisations at various stages of carbon project development process.  The challenge Home to 20 percent of the planet’s forests, Africa is losing trees faster than anywhere else. Protecting and restoring forests and other natural climate solutions (including soil, oceans, and peat) is one of the costeffective ways to fight climate change. It also helps to improve livelihoods and resilience for hundreds of thousands of people.  The One Acre Fund ↗ (OAF) is a forest enterprise that provides sub-Saharan African smallholder farmers with the supplies and knowledge they need to grow more food. The AFCC is helping it to prepare to qualify for carbon credits. Immaculata Magoda from the Tanzanian village of Luganga is one of the one million smallholder farmers in Kenya and Tanzania that OAF helped plant diverse tree species for agroforestry.  “Timber from grevillea (trees) is really good,” she said. “I am expecting to earn good money from them. I may not be around to harvest the trees, but my children will benefit a lot.”  The solution The Africa Forest Carbon Catalyst (AFCC) ↗ programme aims to achieve two main objectives: storing and sequestering carbon, and protecting people and nature from worsening climate change impacts. To accomplish this, the AFCC scouts promising natural climate projects in nine African countries, with a focus on forests and grasslands initiatives. These projects receive comprehensive support from the AFCC, including technical assistance, grant funding, and operational guidance to facilitate their growth. As a result, the AFCC is creating a pipeline of high-quality carbon projects that not only mitigate climate change but also benefit nature and local communities.  Partnership figures  21  high-integrity carbon projects supported in 9 countries  Find out more ↗  20 million  AFCC goals by 2025  tonnes of CO2 avoided or stored each year  500,000 people benefitted, including 5,000 with new green jobs  10 million  hectares protected, restored or better managed"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 18-title\" style=\"top: 61px;left:99px;\" src=\"/2023/static/_content/18-title-1.png\" />\n        <img class=\"abs halfScale 18-title\" style=\"top: 161px;left:100px;\" src=\"/2023/static/_content/18-title-2.png\" />\n\n        <h1 id=\"18-no\" class=\"abs euclid-med 18-no\" style=\"top: 611px; left: 98px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 24}' ></h1>\n        <h1 id=\"18-no\" class=\"abs euclid-med 18-no\" style=\"top: 670px; left: 98px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 45}' ></h1>\n        <h1 id=\"18-no\" class=\"abs euclid-med 18-no\" style=\"top: 739px; left: 98px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 56}' ></h1>\n        <h1 id=\"18-no\" class=\"abs euclid-med 18-no\" style=\"top: 809px; left: 98px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 30}' ></h1>\n        <h1 id=\"18-no\" class=\"abs euclid-med 18-no\" style=\"top: 612px; left: 393px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 155000, \"comma\": true, \"preppend\": \"USD\"}' ></h1>\n\n\n\n        <h1 id=\"18-no\" class=\"abs euclid-med 18-no\" style=\"top: 779px; left: 502px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 958000, \"comma\": true}' ></h1>\n\n        <a class=\"addContentLink\" style=\"top: 575px;left: 391px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/planet-indonesia/\" target=\"_blank\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim\n            .staggerFromTo(cOf(\"18-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"18-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"18-no\")[0])}}, 1.4)\n            .fromTo(cOf(\"18-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"18-no\")[1])}}, 1.5)\n            .fromTo(cOf(\"18-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"18-no\")[2])}}, 1.6)\n            .fromTo(cOf(\"18-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"18-no\")[3])}}, 1.7)\n            .fromTo(cOf(\"18-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"18-no\")[4])}}, 1.8)\n            .fromTo(cOf(\"18-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"18-no\")[5])}}, 1.9)\n            setTimeout(function(){\n              addContentLinks();\n            }, 2800)\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop();\n          resetNumbers(\"18-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "16  Climate adaptation: Building the resilience of communities and ecosystems most vulnerable to climate change  Community-led natural resource management  Planet Indonesia Where West Kalimantan, Borneo, Indonesia  People we support Small-scale fishers and smallholder farmers in indigenous communities near forest reserves and protected areas.  The challenge The 18 communities in these frontline, high ecosystem value locations have limited access to credit and financial services to invest in the long-term conservation of the natural resources they depend upon.  The solution Planet Indonesia facilitates community-led natural resource management through regenerative agriculture and agroforestry. They also create savings and credit funds managed by village conservation cooperatives to help communities safeguard and restore mangroves and forest lands, enhance soil fertility and fishery yields.  We fund community-led conservation cooperatives that: • Sustainably manage forests and coastal mangroves through periodic three-month closures, allowing mud crabs to grow and reproduce. • Promote organic, climate-smart, and agroforestry methods by training farmers to lead mentor groups sharing improved techniques. • Deter the use of forest fires through local reporting, smart patrol, spatial analysis. • Foster ecosystem restoration by selecting and planting over 70,000 native species and restore aquaculture ponds on the coast. • Support local communities through community-run “resilience funds” that provide zero-interest, revolving loans to individuals or groups for health, education or business purposes.  Partnership figures  Find out more ↗  24  USD155,000  conservation cooperatives supported  45  lead farmers provide capacity-building in climate smart agriculture for community farmers  saved in community-managed fund to support regenerative economies  Overall impact of Planet indonesia  56%  cut in smallholder farmer spending through using organic, climate-smart alternatives  30%  rise in small-scale fishery yield following periodic fishing zone closures  958,000  hectares of terrestrial and marine areas protected"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"19-no\" class=\"abs euclid-med 19-no\" style=\"top: 748px; left: 167px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 40000, \"comma\": true}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax();\n          pg19Anim\n            .fromTo(cOf(\"19-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[0])}}, 1)\n        }\n\n        function onPageLeave() {\n          pg19Anim.stop();\n          resetNumbers(\"19-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "17  40,000 people served  Farmer from Laek village, on the Island of Borneo, with pak choi harvest from organic agriculture."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"20-no\" class=\"abs euclid-med 20-no\" style=\"top: 763px; left: 247px; font-size: 1.7em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 111.4, \"preppend\": \"USD\", \"decimals\": 1}' ></h1>\n        <h1 id=\"20-no\" class=\"abs euclid-med 20-no\" style=\"top: 803px; left: 552px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 49}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim\n            .fromTo(cOf(\"20-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[0])}}, 1)\n            .fromTo(cOf(\"20-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[1])}}, 1.1)\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop();\n          resetNumbers(\"20-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "18  USD111.4 million A worker from Cooperativa Agraria Sonomoro del Vraem LTDA in Pangoa, Peru leans over cacao drying beds.  disbursed in a total of 173 loans closed in 2023  49%  of services were gender-inclusive"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 21-title\" style=\"top: 61px;left:65px;\" src=\"/2023/static/_content/21-title-1.png\" />\n        <img class=\"abs halfScale 21-title\" style=\"top: 161px;left:65px;\" src=\"/2023/static/_content/21-title-2.png\" />\n\n        <h1 id=\"21-no\" class=\"abs euclid-med 21-no\" style=\"top: 634px; left: 361px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 3227, \"comma\":true}' ></h1>\n        <h1 id=\"21-no\" class=\"abs euclid-med 21-no\" style=\"top: 692px; left: 361px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 96, \"preppend\":\"+\"}' ></h1>\n        <h1 id=\"21-no\" class=\"abs euclid-med 21-no\" style=\"top: 762px; left: 362px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 111}' ></h1>\n        <h1 id=\"21-no\" class=\"abs euclid-med 21-no\" style=\"top: 821px; left: 361px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 5}' ></h1>\n\n\n\n        <h1 id=\"21-no\" class=\"abs euclid-med 21-no\" style=\"top: 703px; left: 74px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 123}' ></h1>\n        <h1 id=\"21-no\" class=\"abs euclid-med 21-no\" style=\"top: 790px; left: 232px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 91}' ></h1>\n\n        <a class=\"addContentLink\" style=\"top: 581px;left: 61px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/root-capital-3/\" target=\"_blank\"></a>\n        <a class=\"addContentLink\" style=\"top: 272px;left: 387px;width: 198px;height: 12px;\" href=\"https://rootcapital.org/coas-a-gender-forward-cacao-cooperative-in-peru/ \" target=\"_blank\"></a>\n        <a class=\"addContentLink\" style=\"top: 284px;left: 372px;width: 77px;height: 12px;\" href=\"https://rootcapital.org/coas-a-gender-forward-cacao-cooperative-in-peru/ \" target=\"_blank\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim\n            .staggerFromTo(cOf(\"21-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"21-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[0])}}, 1.4)\n            .fromTo(cOf(\"21-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[1])}}, 1.5)\n            .fromTo(cOf(\"21-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[2])}}, 1.6)\n            .fromTo(cOf(\"21-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[3])}}, 1.7)\n            .fromTo(cOf(\"21-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[4])}}, 1.8)\n            .fromTo(cOf(\"21-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[5])}}, 1.9)\n            setTimeout(function(){\n              addContentLinks();\n            }, 2900)\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop();\n          resetNumbers(\"21-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "Trafigura Foundation Annual Report 2023  19  Strengthening livelihoods and climate resilience in cocoa cooperatives  Root Capital Where Peru  People we support Cocoa cooperatives and smallholder farmers.  The challenge Peru is the world’s second-largest producer of organic cocoa, with some 50,000 smallholder farmers, a fifth of whom belong to an association or cooperative. Many of these farmers do not have access to training and financial services to help their business grow and become more resilient to climate change. Rising temperatures and coastal El Niño weather patterns cause torrential rains, landslides, and flooding, destroying thousands of hectares of farmland and community infrastructure.  Root Capital has loaned a total of USD350,000 to the Cooperativa Agraria Sonomoro Del Vraem (COAS) ↗, helping it increase its cocoa production by 50 percent to 1,200 tonnes in 2023, and its farmers to charge higher prices for their crop. Root Capital also provided COAS with training in business and financial management, and in strategic governance. It ran workshops analysing the cooperative’s vulnerability to climate change, and explaining how the use of biofertilisers could improve cacao growth and yield. Other workshops focused on policy changes to render the cooperative more gender-inclusive and open more leadership opportunities to female employees.  The solution Root Capital provides cocoa cooperatives access to credit and financial services, training in business management and tailor-made climate adaptation plans. Their climate resilience advisory services help businesses and smallholder cocoa producers become better equipped to adapt to climate change. Find out more ↗  Partnership figures  3,227  Overall impact of Root Capital  people whose livelihoods have been supported  +96  123  cocoa cooperative employees trained (of whom more than a third were women)  businesses received Agronomic and Climate Resilience Advisory Services  111 days  91%  of all active Root Capital loans filled gaps not met by commercial lenders  of training to 13 cocoa cooperatives  5  cooperatives signed their Climate Adaptation Plans"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 22-title\" style=\"top: 61px;left:99px;\" src=\"/2023/static/_content/22-title-1.png\" />\n      <img class=\"abs halfScale 22-title\" style=\"top: 161px;left:99px;\" src=\"/2023/static/_content/22-title-2.png\" />\n\n      <h1 id=\"22-no\" class=\"abs euclid-med 22-no\" style=\"top: 809px; left: 97px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2100, \"comma\":true}' ></h1>\n\n\n\n      <h1 id=\"22-no\" class=\"abs euclid-med 22-no\" style=\"top: 572px; left: 528px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 20000, \"comma\": true}' ></h1>\n      <h1 id=\"22-no\" class=\"abs euclid-med 22-no\" style=\"top: 778px; left: 437px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 50000, \"comma\": true}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 724px;left: 94px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/boma/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg22Anim = new TimelineMax();\n        pg22Anim\n          .staggerFromTo(cOf(\"22-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"22-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[0])}}, 1.4)\n          .fromTo(cOf(\"22-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[1])}}, 1.5)\n          .fromTo(cOf(\"22-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[2])}}, 1.6)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2600)\n      }\n\n      function onPageLeave() {\n        pg22Anim.stop();\n        resetNumbers(\"22-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "20  Climate adaptation: Building the resilience of communities and ecosystems most vulnerable to climate change  Green livelihoods for dryland communities  BOMA Where Borena Zone, Oromia region, Ethiopia  People we support Nomadic and agro-pastoralist communities  The challenge Despite a rapidly-growing economy, Ethiopia’s per capita income, gender equality and food security are among the lowest in the world. Recurring, severe droughts make it difficult for herders to find water and pasture. This forces them to resort to alternative but destructive livelihood practices such as charcoal harvesting, clearing forest land for fuel wood and building, or mining. Women and girls are bearing the brunt of the impacts of the climate crisis, as increasing scarcity makes their tasks of gathering water, fuel wood, and other non-timber forest and pasture products extremely arduous and time-consuming. They suffer from gender-based discrimination around access to property, assets, education and financial services. This disempowerment is a significant obstacle to effective and sustainable natural resource management.  Compared to community members who did not take the training, Green REAP graduates on average were able to more than triple their business assets by: • Increasing their annual household cash income by a third, and • Growing their cash savings more than fivefold.  Overall impact of BOMA  20,000  The solution BOMA’s Green Rural Entrepreneur Access Program (REAP) increases the resilience of the communities of Africa’s drylands through economic inclusion. Women, youth and refugees are accompanied in the creation of green enterprises through twoyear sequenced interventions combining training, mentoring, grants, saving groups and market connections. Community members are involved in the preservation and restoration of forests and degraded lands through tree nurseries and apiaries.  graduates of BOMA programmes in 2023 benefitted from the grants, training and mentorship for the most vulnerable women, youth, and refugees in Africa’s drylands  Find out more ↗  Partnership figures  2,100  new entrepreneurs enrolled around Yabelo and Borena protected areas  50,000  new participants enrolled and reached"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "21  June 2023: These women in Cholkasa, Yabello, began an entrepreneurial journey with a strategic use of their Jump Grant, raising a few goats and chickens. Now with 23 chickens, they sell eggs and hatch others, paving the way to self-reliance and escaping extreme poverty."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "22  Process of making cassava flour in the house of Dona Maria Lucidalva Godinho in Santarém, state of Pará in the Amazon region."
  }], [(_ref = {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": ""
  }, defineProperty_default()(_ref, "content", "\n      <img class=\"abs halfScale 25-title\" style=\"top: 61px;left:65px;\" src=\"/2023/static/_content/25-title-1.png\" />\n      <img class=\"abs halfScale 25-title\" style=\"top: 161px;left:65px;\" src=\"/2023/static/_content/25-title-2.png\" />\n\n      <h1 id=\"25-no\" class=\"abs euclid-med 25-no\" style=\"top: 296px; left: 360px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 4000, \"comma\":true}' ></h1>\n      <h1 id=\"25-no\" class=\"abs euclid-med 25-no\" style=\"top: 354px; left: 361px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 30, \"preppend\": \"Up to \"}' ></h1>\n      <h1 id=\"25-no\" class=\"abs euclid-med 25-no\" style=\"top: 425px; left: 361px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 30, \"preppend\": \"Up to \"}' ></h1>\n\n\n\n      <h1 id=\"25-no\" class=\"abs euclid-med 25-no\" style=\"top: 634px; left: 481px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1040, \"comma\": true}' ></h1>\n      <h1 id=\"25-no\" class=\"abs euclid-med 25-no\" style=\"top: 760px; left: 209px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 260}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 627px;left: 61px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/conexsus/\" target=\"_blank\"></a>\n    "), defineProperty_default()(_ref, "script", "\n      function onPageEnter() {\n        pg25Anim = new TimelineMax();\n        pg25Anim\n          .staggerFromTo(cOf(\"25-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"25-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[0])}}, 1.4)\n          .fromTo(cOf(\"25-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[1])}}, 1.5)\n          .fromTo(cOf(\"25-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[2])}}, 1.6)\n          .fromTo(cOf(\"25-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[3])}}, 1.7)\n          .fromTo(cOf(\"25-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[4])}}, 1.8)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2800)\n      }\n\n      function onPageLeave() {\n        pg25Anim.stop();\n        resetNumbers(\"25-no\");\n        removeContentLinks();\n      }\n    "), defineProperty_default()(_ref, "searchText", "Trafigura Foundation Annual Report 2023  23  Community enterprises gain access to markets  Conexsus, Institute of Sustainable Connections Where  Partnership targets by 2025  Amazon region, Brazil  People we support Indigenous people, smallholder farmers and traditional communities.  The challenge The escalating deforestation and land degradation of the Amazon threatens the livelihoods of its rural communities, and the integrity of high-value ecosystems. Heavily dependent on forest products and services, the Amazon communities encounter multiple obstacles to access markets and thrive. Located in the remote regions of the Amazon, community enterprises usually lack competitiveness and market linkages, and fail to comply with extensive procurement procedures and demonstrate their social and environmental impact.  The solution  4,000  community members with improved livelihoods  Up to 30%  increased business maturity for community enterprises  Up to 30%  raised their average annual revenue  Overall impact of Conexsus  Conexsus helps community- and family-led enterprises in remote areas of the Amazon gain business maturity and connect to national and international markets, while increasing revenues for traditional livelihoods. When managed sustainably, açai, Brazil nuts, cocoa and other agricultural and extractive activities of the bio-economy can increase the resilience of both ecosystems and people. Find out more ↗  1,040  community enterprises mapped  260  associations and cooperatives engaged across the Amazon region"), _ref)], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 26-title\" style=\"top: 113px;left:50px;\" src=\"/2023/static/_content/26-title-1.png\" />\n        <img class=\"abs halfScale 26-title\" style=\"top: 181px;left:49px;\" src=\"/2023/static/_content/26-text-1.png\" />\n        <img class=\"abs halfScale 26-quote\" style=\"top: 639px;left:84px;\" src=\"/2023/static/_content/26-quote-1.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim\n            .staggerFromTo(cOf(\"26-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"26-quote\"), 1, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8)\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n          resetNumbers(\"26-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "24  Economic opportunities Enable sustainable livelihoods as the backbone of thriving communities While the Trafigura Foundation is dedicated to addressing climate adaptation within its new strategy, the Foundation also funds non-profit partners’ work in other fields to implement programmes that contribute to further broadening our social impact. Sustainable livelihoods are the backbone of thriving communities, fostering self-reliance and resilience against economic uncertainty as well as sociopolitical and climate change-related shocks. By creating livelihood opportunities for the most underprivileged, the Foundation works to promote inclusivity and reduce inequality. Upskilling and training programmes for disadvantaged youth, women, and unemployed individuals are a crucial step towards opening entrepreneurship and employment opportunities. The Foundation has also invested in organisations that support fair working conditions for seafarers and artisanal and small-scale miners. When remote and rural communities gain access to services such as financial services, they can improve health and education, and safely contribute to economic growth and community development.  Voices of Partners  By engaging local communities on all levels, we can advance a sustainable model that puts the focus on people and the opportunities that make it possible for them to thrive. Nivi Sharma, CEO, Bridges to Prosperity"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Trafigura Foundation Annual Report 2023  25"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 28-title\" style=\"top: 62px;left:99px;\" src=\"/2023/static/_content/28-title-1.png\" />\n        <img class=\"abs halfScale 28-title\" style=\"top: 161px;left:99px;\" src=\"/2023/static/_content/28-title-2.png\" />\n        <img class=\"abs halfScale 28-quote\" style=\"top: 399px;left:355px;\" src=\"/2023/static/_content/28-quote-1.png\" />\n\n        <h1 id=\"28-no\" class=\"abs euclid-med 28-no\" style=\"top: 494px; left: 97px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 200}' ></h1>\n        <h1 id=\"28-no\" class=\"abs euclid-med 28-no\" style=\"top: 552px; left: 99px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 124}' ></h1>\n\n        <a class=\"addContentLink\" style=\"top: 346px;left: 392px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/don-bosco/\" target=\"_blank\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim\n            .staggerFromTo(cOf(\"28-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"28-quote\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.5)\n            .fromTo(cOf(\"28-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"28-no\")[0])}}, 1.7)\n            .fromTo(cOf(\"28-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"28-no\")[1])}}, 1.8)\n            setTimeout(function(){\n              addContentLinks();\n            }, 2800)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n          resetNumbers(\"28-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "26  Economic opportunities: Enable sustainable livelihoods as the backbone of thriving communities  Employment opportunities for youth  Fundación Don Bosco Where  The solution  Huesca and Sevilla, Spain  Don Bosco works to improve the employability of youth through guidance to career development, professional training, personal mentoring, and job placement support relying on a solid network of business partners.  People we support Disadvantaged women, migrants, people who use drugs, and unemployed people under 30 years of age.  The challenge The labour market in the Southern region of Andalucía suffers severe structural issues, including high youth unemployment. Marginalised people have a hard time overcoming social exclusion and securing a job in an already-fragmented job market.  Partnership figures  200  people trained  124  people contracted in their field of work of interest  Find out more ↗  The Trafigura Foundation has been an essential support for each of the highly vulnerable young people. Over the past two years, we have undertaken the commitment and challenge of creating a truly positive impact on the development of their life paths. Fundación Don Bosco Educational Team"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 29-title\" style=\"top: 62px;left:65px;\" src=\"/2023/static/_content/29-title-1.png\" />\n        <img class=\"abs halfScale 29-title\" style=\"top: 161px;left:65px;\" src=\"/2023/static/_content/29-title-2.png\" />\n        <img class=\"abs halfScale 29-quote\" style=\"top: 683px;left:321px;\" src=\"/2023/static/_content/29-quote-1.png\" />\n\n        <h1 id=\"29-no\" class=\"abs euclid-med 29-no\" style=\"top: 530px; left: 361px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 53}' ></h1>\n        <h1 id=\"29-no\" class=\"abs euclid-med 29-no\" style=\"top: 589px; left: 361px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 43}' ></h1>\n\n        <a class=\"addContentLink\" style=\"top: 688px;left: 61px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/aama/\" target=\"_blank\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim\n            .staggerFromTo(cOf(\"29-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"29-quote\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.5)\n            .fromTo(cOf(\"29-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[0])}}, 1.7)\n            .fromTo(cOf(\"29-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[1])}}, 1.8)\n            setTimeout(function(){\n              addContentLinks();\n            }, 2800)\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop();\n          resetNumbers(\"29-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "Trafigura Foundation Annual Report 2023  27  Empowering Latino young people  Association for the Advancement of Mexican Americans, AAMA  Where  Partnership figures  Houston, Texas, USA  People we support Underserved youth  The challenge The Houston area is home to around 110,000 youth and young adults who neither work nor study.  The solution The AAMA Work and Learn Center provides training in career readiness, digital literacy, web development and leadership development for Houston youth. Find out more ↗  53  students enrolled  43  graduates  13  students gained employment out of the 43 graduates  19 It has been a wonderful learning experience and brought me to new interest in graphic design. I have connected with new people and created projects I never thought I could make before. Daniela Williams, AAMA training participant  of the 43 graduates gained internship or postsecondary training"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 30-title\" style=\"top: 62px;left:99px;\" src=\"/2023/static/_content/30-title-1.png\" />\n      <img class=\"abs halfScale 30-title\" style=\"top: 161px;left:99px;\" src=\"/2023/static/_content/30-title-2.png\" />\n      <img class=\"abs halfScale 30-quote\" style=\"top: 559px;left:58px;\" src=\"/2023/static/_content/30-quote-1.png\" />\n\n      <h1 id=\"30-no\" class=\"abs euclid-med 30-no\" style=\"top: 295px; left: 396px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1123, \"comma\":true}' ></h1>\n      <h1 id=\"30-no\" class=\"abs euclid-med 30-no\" style=\"top: 366px; left: 394px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 88}' ></h1>\n      <h1 id=\"30-no\" class=\"abs euclid-med 30-no\" style=\"top: 436px; left: 394px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 94}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 484px;left: 392px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/reach/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg30Anim = new TimelineMax();\n        pg30Anim\n          .staggerFromTo(cOf(\"30-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"30-quote\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.5)\n          .fromTo(cOf(\"30-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"30-no\")[0])}}, 1.7)\n          .fromTo(cOf(\"30-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"30-no\")[1])}}, 1.8)\n          .fromTo(cOf(\"30-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"30-no\")[2])}}, 1.9)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2900)\n      }\n\n      function onPageLeave() {\n        pg30Anim.stop();\n        resetNumbers(\"30-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "28  Economic opportunities: Enable sustainable livelihoods as the backbone of thriving communities  Access to jobs for disadvantaged youth  Research for Education and Career Help Institute, REACH Where  Partnership figures  Vietnam  People we support Young people who suffer from poverty or discrimination, such as survivors of human trafficking victims of domestic violence, those living with HIV/ AIDS or disabilities, street children, migrant youth, school dropouts, and ethnic minorities.  The challenge Limited access to technical training and skills; mismatch of skills and labour market demand; insufficient career guidance and support; prejudice about marginalised youth.  The solution REACH provides practical and demand-driven skills training, soft skill development, and job placement support to help youth find decent employment, and also provides support for graduates’ future development.  1,123  students completed training, including 148 students with disabilities (13% of the total)  88%  of trained youth placed in employment up to 6 months after graduation  94%  of graduates reported an improved quality of life  Find out more ↗  This year, REACH celebrated its 15th anniversary, marking another significant milestone in our journey to empower the most disadvantaged youth across Vietnam. Within 15 years, our impact reached a total of 21,000 disadvantaged youth with vocational training and decent job placement opportunities. Ms. Pham Thi Thanh Tam, Executive Director, REACH"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 31-title\" style=\"top: 62px;left:65px;\" src=\"/2023/static/_content/31-title-1.png\" />\n      <img class=\"abs halfScale 31-title\" style=\"top: 161px;left:65px;\" src=\"/2023/static/_content/31-title-2.png\" />\n\n      <h1 id=\"31-no\" class=\"abs euclid-med 31-no\" style=\"top: 564px; left: 65px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 83}' ></h1>\n      <h1 id=\"31-no\" class=\"abs euclid-med 31-no\" style=\"top: 634px; left: 65px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 97}' ></h1>\n      <h1 id=\"31-no\" class=\"abs euclid-med 31-no\" style=\"top: 704px; left: 65px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 33}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 465px;left: 61px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/efe-egypt/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg31Anim = new TimelineMax();\n        pg31Anim\n          .staggerFromTo(cOf(\"31-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"31-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[0])}}, 1.5)\n          .fromTo(cOf(\"31-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[1])}}, 1.6)\n          .fromTo(cOf(\"31-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[2])}}, 1.7)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2700)\n      }\n\n      function onPageLeave() {\n        pg31Anim.stop();\n        resetNumbers(\"31-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "Trafigura Foundation Annual Report 2023  29  Upskill young people for the job market  Education for Employment, EFE-Egypt Where Cairo and Alexandria, Egypt  People we support Vulnerable youth  The challenge Egypt faces high youth unemployment rates due to lack of economic opportunities. As of 2020, the unemployment rate for Egyptian youth between 15 to 24 years of age was 30 percent.  The solution Education for Employment provides technical, soft or self-employment skills training to Egyptian youth. Find out more ↗  Partnership figures  20  graduates reported successful job placements upon graduation  83  youth enrolled in entrepreneurship classes, of which 78 graduated (97% women)  33  new jobs collectively created by Alumni within their businesses  97  youth enrolled in job training, of which 91 graduated (77% women)  Hala Khaled Ragab’s story Inspired by her daughter's sleep struggles, Hala founded Sweet Dreams to assist parents and enhance babies' sleep thanks to comfortable swaddles and sleeping bags. Despite lacking business experience, she attended workshops powered by EFE-Egypt. Winning a startup competition brought recognition and facilitated the growth of her company. She now manages a successful income-generating business employing one person, with nearly 5,000 followers on social media."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 32-title\" style=\"top: 62px;left:99px;\" src=\"/2023/static/_content/32-title-1.png\" />\n      <img class=\"abs halfScale 32-title\" style=\"top: 161px;left:99px;\" src=\"/2023/static/_content/32-title-2.png\" />\n\n      <h1 id=\"32-no\" class=\"abs euclid-med 32-no\" style=\"top: 295px; left: 394px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 390}' ></h1>\n      <h1 id=\"32-no\" class=\"abs euclid-med 32-no\" style=\"top: 354px; left: 394px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 371}' ></h1>\n      <h1 id=\"32-no\" class=\"abs euclid-med 32-no\" style=\"top: 425px; left: 394px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 50}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 465px;left: 95px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/adie/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg32Anim = new TimelineMax();\n        pg32Anim\n          .staggerFromTo(cOf(\"32-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"32-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"32-no\")[0])}}, 1.5)\n          .fromTo(cOf(\"32-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"32-no\")[1])}}, 1.6)\n          .fromTo(cOf(\"32-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"32-no\")[2])}}, 1.7)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2700)\n      }\n\n      function onPageLeave() {\n        pg32Anim.stop();\n        resetNumbers(\"32-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "30  Economic opportunities: Enable sustainable livelihoods as the backbone of thriving communities  Access to microcredit  Association pour le droit à l’initiative économique, Adie Where  Partnership figures  New Caledonia, French overseas territory  People we support Disadvantaged population in remote areas.  The challenge New Caledonia faces a lack of employment opportunities and high poverty rates, particularly among indigenous Kanak communities.  The solution Adie provides micro-entrepreneurs, the unemployed and young people access to financial services, enterprise creation, and business mentoring. Find out more ↗  390  microcredits granted  371  people financed and supported for business creation or development  50%  beneficiaries are women"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 33-title\" style=\"top: 62px;left:65px;\" src=\"/2023/static/_content/33-title-1.png\" />\n      <img class=\"abs halfScale 33-title\" style=\"top: 161px;left:65px;\" src=\"/2023/static/_content/33-title-2.png\" />\n\n      <h1 id=\"33-no\" class=\"abs euclid-med 33-no\" style=\"top: 295px; left: 360px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 413}' ></h1>\n      <h1 id=\"33-no\" class=\"abs euclid-med 33-no\" style=\"top: 354px; left: 360px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 60}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 499px;left: 61px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/germinal/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg33Anim = new TimelineMax();\n        pg33Anim\n          .staggerFromTo(cOf(\"33-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"33-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"33-no\")[0])}}, 1.5)\n          .fromTo(cOf(\"33-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"33-no\")[1])}}, 1.6)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2600)\n      }\n\n      function onPageLeave() {\n        pg33Anim.stop();\n        resetNumbers(\"33-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "Trafigura Foundation Annual Report 2023  31  Support to self-employed workers  Germinal Where  Partnership figures  Northern region of France  People we support People facing social and professional difficulty: longterm job seekers, single parents, people on welfare.  The challenge In France, there are a growing number of unemployed people who are experiencing social exclusion. They find it hard to find a paying job, let alone set up a new business or self-employed venture.  The solution Germinal offers long-term training and financial support to the unemployed, to help them develop their independent activity, gain self-confidence and eventually fully integrate their community. Find out more ↗  413  people trained and mentored  60  people received seed funding for their business"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 34-title\" style=\"top: 62px;left:99px;\" src=\"/2023/static/_content/34-title-1.png\" />\n      <img class=\"abs halfScale 34-title\" style=\"top: 161px;left:99px;\" src=\"/2023/static/_content/34-title-2.png\" />\n      <img class=\"abs halfScale 34-quote\" style=\"top: 652px;left:58px;\" src=\"/2023/static/_content/34-quote-1.png\" />\n\n      <h1 id=\"34-no\" class=\"abs euclid-med 34-no\" style=\"top: 681px; left: 394px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 50}' ></h1>\n      <h1 id=\"34-no\" class=\"abs euclid-med 34-no\" style=\"top: 740px; left: 394px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 250, \"preppend\": \"+\"}' ></h1>\n      <h1 id=\"34-no\" class=\"abs euclid-med 34-no\" style=\"top: 809px; left: 396px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 194}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 543px;left: 391px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/word-of-mouth/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg34Anim = new TimelineMax();\n        pg34Anim\n          .staggerFromTo(cOf(\"34-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"34-quote\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.5)\n          .fromTo(cOf(\"34-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[0])}}, 1.7)\n          .fromTo(cOf(\"34-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[1])}}, 1.8)\n          .fromTo(cOf(\"34-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[2])}}, 1.9)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2900)\n      }\n\n      function onPageLeave() {\n        pg34Anim.stop();\n        resetNumbers(\"34-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "32  Economic opportunities: Enable sustainable livelihoods as the backbone of thriving communities  Supporting the informal economy’s entrepreneurs  Word of Mouth  Where  The solution  Cape Town and Johannesburg, South Africa  Word of Mouth has created an online marketplace to unlock the potential of the informal economy and informal entrepreneurs. The marketplace stimulates local trade by helping informal workers to run a successful e-commerce business by reaching customers, selling, and shipping their products.  People we support Informal workers living in Cape Town area townships.  The challenge South Africa has a high unemployment rate, with youth disproportionately affected (60 percent unemployment for those aged 15-24 and 40 percent unemployment for those aged 25-34 years). This drives many people into informal employment, where workers do not have access to financing and training to grow their businesses.  The funding provided by the Trafigura Foundation was catalytic for Word of Mouth. Not only did it create business continuity during a period of rapid growth, but also instilled confidence with prospective donors. This resulted in the organisation being able to secure additional funding, enabling us to scale our reach and expand our geographical presence. Simon Barson, Founder, Word of Mouth  Find out more ↗  Partnership figures  50%  increased sales for business owners  +250  informal business owners generated over USD200,000 of income  194  youth supported to set-up and run profitable online businesses"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 35-title\" style=\"top: 62px;left:65px;\" src=\"/2023/static/_content/35-title-1.png\" />\n      <img class=\"abs halfScale 35-title\" style=\"top: 161px;left:65px;\" src=\"/2023/static/_content/35-title-2.png\" />\n\n      <h1 id=\"35-no\" class=\"abs euclid-med 35-no\" style=\"top: 593px; left: 64px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 31889, \"comma\":true}' ></h1>\n      <h1 id=\"35-no\" class=\"abs euclid-med 35-no\" style=\"top: 652px; left: 64px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 831}' ></h1>\n      <h1 id=\"35-no\" class=\"abs euclid-med 35-no\" style=\"top: 721px; left: 64px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 26}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 466px;left: 61px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/rede-asta/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg35Anim = new TimelineMax();\n        pg35Anim\n          .staggerFromTo(cOf(\"35-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"35-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"35-no\")[0])}}, 1.5)\n          .fromTo(cOf(\"35-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"35-no\")[1])}}, 1.6)\n          .fromTo(cOf(\"35-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"35-no\")[2])}}, 1.7)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2700)\n      }\n\n      function onPageLeave() {\n        pg35Anim.stop();\n        resetNumbers(\"35-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "Trafigura Foundation Annual Report 2023  Boosting microentrepreneurs’ revenues  Rede Asta Where Itaguai, Brazil  People we support Low-income, mostly female, entrepreneurs.  The challenge Many micro-entrepreneurs in Brazil lack the digital literacy required to promote their handmade products and increase their local sales.  The solution The Pertinho de Casa digital platform helps small businesses market themselves online and at in-person fairs. Find out more ↗  Partnership figures  31,889  entrepreneurs engaged nationwide in Brazil  831  micro- and nano-entrepreneurs supported in Itaguaí, of which 68% are women  26  fairs and events organised in Itaguai and online marketplace launched  33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 36-title\" style=\"top: 62px;left:99px;\" src=\"/2023/static/_content/36-title-1.png\" />\n      <img class=\"abs halfScale 36-title\" style=\"top: 161px;left:99px;\" src=\"/2023/static/_content/36-title-2.png\" />\n      <img class=\"abs halfScale 36-quote\" style=\"top: 386px;left:58px;\" src=\"/2023/static/_content/36-quote-1.png\" />\n\n      <h1 id=\"36-no\" class=\"abs euclid-med 36-no\" style=\"top: 623px; left: 394px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 60}' ></h1>\n      <h1 id=\"36-no\" class=\"abs euclid-med 36-no\" style=\"top: 682px; left: 394px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 85}' ></h1>\n      <h1 id=\"36-no\" class=\"abs euclid-med 36-no\" style=\"top: 751px; left: 393px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 58}' ></h1>\n      <h1 id=\"36-no\" class=\"abs euclid-med 36-no\" style=\"top: 821px; left: 394px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 85}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 456px;left: 392px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/sikanda/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg36Anim = new TimelineMax();\n        pg36Anim\n          .staggerFromTo(cOf(\"36-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"36-quote\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.5)\n          .fromTo(cOf(\"36-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"36-no\")[0])}}, 1.7)\n          .fromTo(cOf(\"36-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"36-no\")[1])}}, 1.8)\n          .fromTo(cOf(\"36-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"36-no\")[2])}}, 1.9)\n          .fromTo(cOf(\"36-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"36-no\")[3])}}, 2)\n          setTimeout(function(){\n            addContentLinks();\n          }, 3000)\n      }\n\n      function onPageLeave() {\n        pg36Anim.stop();\n        resetNumbers(\"36-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "34  Economic opportunities: Enable sustainable livelihoods as the backbone of thriving communities  Empowering marginalised women  Solidaridad Internacional Kanda, SiKanda Where  The challenge  Oaxaca State, Mexico  A number of factors are keeping women from thriving in this municipality, including genderbased discrimination, limited participation inside and outside the community, and the lack of a safety-support social network to overcome a diversity of violences.  People we support Women of all ages in the remote area of the Villa de Zaachila Municipality.  The solution  The Women in Entrepreneurship project played a crucial role in helping progress in various aspects - financially, emotionally, and in shaping my attitude and interactions with people. I learned to value my work and myself.  The Mujeres A.V.E. ↗ programme offers business training, networking, psychosocial services, and legal support to female micro-entrepreneurs, to improve their small businesses and increase their income and well-being. The programme also fosters the establishment of solidarity networks. Find out more ↗  Apolina Zurita, who runs a tailor workshop called ‘Costuras Pola’  Partnership figures  60  women completed Social Economy training  85  women received training to improve the quality of their products  58  women received seed funding to improve their businesses  85%  of participants increased their businesses sales"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 37-title\" style=\"top: 62px;left:65px;\" src=\"/2023/static/_content/37-title-1.png\" />\n      <img class=\"abs halfScale 37-title\" style=\"top: 161px;left:65px;\" src=\"/2023/static/_content/37-title-2.png\" />\n\n      <h1 id=\"37-no\" class=\"abs euclid-med 37-no\" style=\"top: 483px; left: 180px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 4600, \"comma\": true}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 346px;left: 357px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/fondem/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg37Anim = new TimelineMax();\n        pg37Anim\n          .staggerFromTo(cOf(\"37-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"37-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"37-no\")[0])}}, 1.5)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2500)\n      }\n\n      function onPageLeave() {\n        pg37Anim.stop();\n        resetNumbers(\"37-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "Trafigura Foundation Annual Report 2023  35  Access to sustainable energy  Fondation Energies pour le Monde, Fondem Where  The solution  Mopti region, Mali  The Solsomati project provides mini-solar power plants with a distribution network and prepayment metres that are managed by several villages, sharing expertise with local communities in solar installation maintenance and distribution.  People we support Remote rural communities.  The challenge Lack of access to basic services (such as health, education, administration, drinking water) and socioeconomic development without access to electricity.  Find out more ↗"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 38-title\" style=\"top: 62px;left:99px;\" src=\"/2023/static/_content/38-title-1.png\" />\n      <img class=\"abs halfScale 38-title\" style=\"top: 161px;left:99px;\" src=\"/2023/static/_content/38-title-2.png\" />\n\n      <h1 id=\"38-no\" class=\"abs euclid-med 38-no\" style=\"top: 564px; left: 98px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 60}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 476px;left: 94px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/bridges-to-prosperity/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg38Anim = new TimelineMax();\n        pg38Anim\n          .staggerFromTo(cOf(\"38-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"38-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"38-no\")[0])}}, 1.5)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2500)\n      }\n\n      function onPageLeave() {\n        pg38Anim.stop();\n        resetNumbers(\"38-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "36  Economic opportunities: Enable sustainable livelihoods as the backbone of thriving communities  Access to services for remote villagers  Bridges to Prosperity Where Rwanda  People we support Isolated rural communities.  The challenge Almost a quarter of a billion people around the world do not have safe access to critical resources such as health care, education, or employment due to an impassable river.  The solution In partnership with the Government of Rwanda, Bridges to Prosperity builds trail bridges to connect communities to services and markets. Find out more ↗  Partnership figures  60  trail bridges built in Rwanda, creating new safe access to 200,000 people  Before the bridge, women in labour during the rainy season risked their lives to cross the river or give birth at home without medical support. Some women and their babies died. Now, healthcare workers are able to safely reach women in their homes to support them through delivery."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 39-title\" style=\"top: 62px;left:65px;\" src=\"/2023/static/_content/39-title-1.png\" />\n        <img class=\"abs halfScale 39-title\" style=\"top: 161px;left:65px;\" src=\"/2023/static/_content/39-title-2.png\" />\n\n        <h1 id=\"39-no\" class=\"abs euclid-med 39-no\" style=\"top: 395px; left: 361px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 8055, \"comma\":true}' ></h1>\n        <h1 id=\"39-no\" class=\"abs euclid-med 39-no\" style=\"top: 476px; left: 362px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 11}' ></h1>\n\n        <a class=\"addContentLink\" style=\"top: 449px;left: 61px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/alliance-for-responsible-mining-arm/\" target=\"_blank\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim\n            .staggerFromTo(cOf(\"39-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"39-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"39-no\")[0])}}, 1.5)\n            .fromTo(cOf(\"39-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"39-no\")[1])}}, 1.6)\n            setTimeout(function(){\n              addContentLinks();\n            }, 2600)\n        }\n\n        function onPageLeave() {\n          pg38Anim.stop();\n          resetNumbers(\"38-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "Trafigura Foundation Annual Report 2023  37  Improving the business of artisanal miners  Alliance for Responsible Mining, ARM Where  The solution  China and global  The Alliance for Responsible Mining supports miners in their business, and develops and implements standards (such as Fairmined) and certification systems for responsible artisanal and small-scale mining and sourcing practices.  People we support Artisanal and small-scale miners.  The challenge Artisanal and small-scale miners (ASM) face numerous challenges including health and safety risks, environmental degradation, and social vulnerabilities. Their informal status often leaves ASM miners without the support and resources they need to improve their conditions and to develop their mining activity in a responsible way. Find out more ↗  Partnership figures  11  artisanal- and small-scale mining organisations certified as Fairmined  8,055  small-scale miners took part in ARM’s interventions, of which 13% are women, 44% are in Latin America, and 56% are in Africa"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 40-title\" style=\"top: 62px;left:99px;\" src=\"/2023/static/_content/40-title-1.png\" />\n      <img class=\"abs halfScale 40-title\" style=\"top: 161px;left:99px;\" src=\"/2023/static/_content/40-title-2.png\" />\n      <img class=\"abs halfScale 40-quote\" style=\"top: 507px;left:354px;\" src=\"/2023/static/_content/40-quote-1.png\" />\n\n      <h1 id=\"40-no\" class=\"abs euclid-med 40-no\" style=\"top: 679px; left: 394px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 8602, \"comma\":true}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 719px;left: 95px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/iswan/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg40Anim = new TimelineMax();\n        pg40Anim\n          .staggerFromTo(cOf(\"40-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"40-quote\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.5)\n          .fromTo(cOf(\"40-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"40-no\")[0])}}, 1.7)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2700)\n      }\n\n      function onPageLeave() {\n        pg40Anim.stop();\n        resetNumbers(\"40-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "38  Economic opportunities: Enable sustainable livelihoods as the backbone of thriving communities  Supporting seafarers worldwide  International Seafarers' Welfare and Assistance Network, ISWAN  Where Global  The challenge Seafarers, who are responsible for transporting 80 percent of the world's goods, face long periods away from their family and friends with limited or no communication access, fast turnaround in ports with restricted or no shore leave, reduced crew numbers, and increased workloads.  It feels good to hear from a seafarer that they feel better after talking to us and to assure them that their mental health matters; they matter. Counsellor, Helpline Officer  The solution  Partnership figures  ISWAN offers comprehensive support, including a 24/7 helpline, to help seafarers cope with their long periods away from home and manage challenging situations both at sea and ashore.  8,602  Find out more ↗  seafarers and family members assisted by ISWAN helplines"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 41-title\" style=\"top: 62px;left:65px;\" src=\"/2023/static/_content/41-title-1.png\" />\n      <img class=\"abs halfScale 41-title\" style=\"top: 161px;left:65px;\" src=\"/2023/static/_content/41-title-2.png\" />\n      <img class=\"abs halfScale 41-quote\" style=\"top: 436px;left:321px;\" src=\"/2023/static/_content/41-quote-1.png\" />\n\n      <h1 id=\"41-no\" class=\"abs euclid-med 41-no\" style=\"top: 296px; left: 361px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 39}' ></h1>\n      <h1 id=\"41-no\" class=\"abs euclid-med 41-no\" style=\"top: 365px; left: 363px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 569px;left: 61px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/smart-freight-centre/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg41Anim = new TimelineMax();\n        pg41Anim\n          .staggerFromTo(cOf(\"41-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"41-quote\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.5)\n          .fromTo(cOf(\"41-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"41-no\")[0])}}, 1.7)\n          .fromTo(cOf(\"41-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"41-no\")[1])}}, 1.8)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2800)\n      }\n\n      function onPageLeave() {\n        pg41Anim.stop();\n        resetNumbers(\"41-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "Trafigura Foundation Annual Report 2023  39  Promoting low-emission global freight sector  Smart Freight Centre Where  Partnership figures  Global and China  The challenge Transport demand will grow in the years to come. By 2050, freight demand will roughly double, with the consequent increase of CO2 emissions.  The solution Improve the capacity of logistics industry players in China and around the world to develop and implement zero emission solutions and embark on a journey of sustainable logistics. We supported the development and launch of a Sustainable Logistics Roadmap training curriculum for China.  39  companies attended sustainable logistics training (in China)  1  training curriculum developed for zero-emissions logistics in China  In addition, Smart Freight Centre released in 2023 a new GLEC Framework 3.0 to further accelerate freight decarbonisation through an updated method to calculate the carbon footprint of the global logistics supply chain. The new ISO14083 standard was built on the principles of the GLEC Framework, which will serve as a formally recognised global standard for calculating GHG emissions from transport chains (including logistics and freight).  The Sustainable Logistics Roadmap training provided theoretic guidance as well as real world best practices to decarbonise logistics, it is very valuable for shippers who wants to help and collaborate with their logistics service providers.  Find out more ↗  Anna Liu, Sustainability Manager of IKEA China, participant of the pilot training"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 42-title\" style=\"top: 62px;left:87px;\" src=\"/2023/static/_content/42-title-1.png\" />\n      <img class=\"abs halfScale 42-title\" style=\"top: 161px;left:87px;\" src=\"/2023/static/_content/42-title-2.png\" />\n\n      <h1 id=\"42-no\" class=\"abs euclid-med 42-no\" style=\"top: 594px; left: 84px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 678}' ></h1>\n      <h1 id=\"42-no\" class=\"abs euclid-med 42-no\" style=\"top: 674px; left: 84px; font-size: 1.4em; font-weight: 300; color: #454547; padding: 0px; margin: 0px;\"  data-number='{\"to\": 22}' ></h1>\n\n      <a class=\"addContentLink\" style=\"top: 483px;left: 81px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/partner-stories/the-international-rescue-committee-irc-2/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg42Anim = new TimelineMax();\n        pg42Anim\n          .staggerFromTo(cOf(\"42-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"42-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"42-no\")[0])}}, 1.5)\n          .fromTo(cOf(\"42-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"42-no\")[1])}}, 1.6)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2600)\n      }\n\n      function onPageLeave() {\n        pg42Anim.stop();\n        resetNumbers(\"42-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "40  Economic opportunities: Enable sustainable livelihoods as the backbone of thriving communities  Delivering health services for at-risk populations  The International Rescue Committee, IRC Where  The solution  Kenya, Somalia, Ethiopia, Central African Republic, Democratic Republic of the Congo, Sudan, South Sudan, Jordan, Thailand, Myanmar, Uganda, Chad and Pakistan  The IRC’s Strengthening Capacity and Access for Pharma (SCAP) programme ensures the uninterrupted supply of safe, quality, and costeffective pharmaceuticals and medical commodities to at-risk populations.  People we serve Thousands of vulnerable or displaced women and children have had to leave their homes in search of safe shelter.  The challenge The International Rescue Committee identified primary healthcare as a strategic priority in 13 countries. Its global health operations reach more than 30 countries, and some 27 million people, each year. Find out more ↗  Partnership figures  678  IRC staff members in 10 countries have enrolled on the Health Supply Chain Management e-learning course  22  critical infrastructure upgrades completed  We supported the IRC in increasing the capacity of its programmes by recruiting new pharmacists in 10 countries, strengthening critical medical warehouse infrastructure in five countries, providing technical support and training to upskill pharmacists, and improving pharmaceutical supply chain data monitoring to support providers and patients in effectively managing their health."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "41"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 44-title\" style=\"top: 113px;left:50px;\" src=\"/2023/static/_content/44-title-1.png\" />\n\n      <h1 id=\"44-no\" class=\"abs euclid-med 44-no\" style=\"top: 686px; left: 100px; font-size: 1.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 23, \"preppend\": \"1 in \"}' ></h1>\n      <h1 id=\"44-no\" class=\"abs euclid-med 44-no\" style=\"top: 757px; left: 97px; font-size: 1.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 0.5, \"decimals\":1}' ></h1>\n    ",
    "script": "\n      function onPageEnter() {\n        pg44Anim = new TimelineMax();\n        pg44Anim\n          .staggerFromTo(cOf(\"44-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"44-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"44-no\")[0])}}, 1.5)\n          .fromTo(cOf(\"44-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"44-no\")[1])}}, 1.6)\n      }\n\n      function onPageLeave() {\n        pg44Anim.stop();\n        resetNumbers(\"44-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "42  Disaster prevention and response Climate change heightens the frequency and severity of extreme weather events worldwide. Rising sea levels amplify destruction caused by storm surges and coastal flooding. Changes in precipitation patterns have prolonged droughts, exacerbated wildfires and reduced food and water security. According to the latest report of the Intergovernmental Panel on Climate Change (IPCC), climatic and non-climatic risks are quickly compounding into increasingly complex risks including human mortality, food-borne and water-borne diseases, mental health challenges, trauma, material damages and loss of livelihoods. Though no region will be spared from the projected further increases in climate hazards, the less-resilient mountainous, rural or coastal communities of low-income countries stand to lose the most. Investing in disaster risk reduction saves lives and money. The more holistic, anticipatory and forward-looking the interventions, the better. Building frontline communities’ preparedness and resilience to shocks is a moral and cost-effective imperative. When disasters occurred in 2023, we supported organisations offering timely and effective relief and recovery efforts, including endeavours to restore infrastructure, livelihoods, and basic services. We prioritised projects that address the immediate needs of affected communities while considering their long-term recovery and resilience-building.  1 in 23 people  on the planet now needs humanitarian assistance, twice the number compared to just four years ago  0.5%  for every USD100 spent on development aid between 2010-2018, only 47 cents were allocated to disaster risk reduction"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Trafigura Foundation Annual Report 2023  43"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 46-title\" style=\"top: 62px;left:99px;\" src=\"/2023/static/_content/46-title-1.png\" />\n      <img class=\"abs halfScale 46-title\" style=\"top: 161px;left:99px;\" src=\"/2023/static/_content/46-title-2.png\" />\n      <img class=\"abs halfScale 46-quote\" style=\"top: 273px;left:353px;\" src=\"/2023/static/_content/46-quote-1.png\" />\n\n      <a class=\"addContentLink\" style=\"top: 499px;left: 391px;width: 81px;height: 18px;\" href=\"https://trafigurafoundation.org/news/supporting-the-un-led-operation/\" target=\"_blank\"></a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg46Anim = new TimelineMax();\n        pg46Anim\n          .staggerFromTo(cOf(\"46-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"46-quote\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.5)\n          setTimeout(function(){\n            addContentLinks();\n          }, 2500)\n      }\n\n      function onPageLeave() {\n        pg46Anim.stop();\n        resetNumbers(\"46-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "44  Disaster prevention and response  Preventing disasters  Avoiding an oil spill in the Red Sea Yemen Partner: United Nations Development Programme (UNDP) Since the outbreak of the war in 2015, the supertanker FSO Safer was decaying off Yemen’s coast, threatening to spill more than one million barrels of oil into the Red Sea. A potential oil spill would have been a major disaster, affecting the 17 million people in Yemen already in need of food aid. It could have cost hundreds of thousands of jobs in the fishing industry, not to mention the decades for the marine ecosystem to recover. In August 2023, the United Nations launched an emergency operation to pump and transfer the oil from the 47-year-old vessel to a replacement one. Joining partners including the Government of Switzerland and the UN Global Compact Network Switzerland and Liechtenstein, we donated USD2 million to the recovery plan. The Safer still holds viscous oil residue that will be removed during the operation’s final phase.  Support from the private sector was crucial to prevent the worstcase scenario. The developing security situation in the Red Sea, which is constantly evolving has resulted in unforeseen operational and financial challenges. After much consideration, the UN had no option but to pause the project at this time, but we continue to follow developments carefully and closely.” Janthomas Hiemstra, Project Manager, UNDP Find out more ↗"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 47-title\" style=\"top: 62px;left:65px;\" src=\"/2023/static/_content/47-title-1.png\" />\n      <img class=\"abs halfScale 47-title\" style=\"top: 161px;left:65px;\" src=\"/2023/static/_content/47-title-2.png\" />\n\n      <h1 id=\"47-no\" class=\"abs euclid-med 47-no\" style=\"top: 250px; left: 199px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 4}' ></h1>\n      <h1 id=\"47-no\" class=\"abs euclid-med 47-no\" style=\"top: 404px; left: 179px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 329}' ></h1>\n      <h1 id=\"47-no\" class=\"abs euclid-med 47-no\" style=\"top: 601px; left: 563px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 145000, \"comma\": true}' ></h1>\n      <h1 id=\"47-no\" class=\"abs euclid-med 47-no\" style=\"top: 644px; left: 413px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 382000, \"comma\": true}' ></h1>\n      <h1 id=\"47-no\" class=\"abs euclid-med 47-no\" style=\"top: 774px; left: 343px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 146000, \"comma\": true}' ></h1>\n    ",
    "script": "\n      function onPageEnter() {\n        pg47Anim = new TimelineMax();\n        pg47Anim\n          .staggerFromTo(cOf(\"47-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"47-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"47-no\")[0])}}, 1.5)\n          .fromTo(cOf(\"47-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"47-no\")[1])}}, 1.6)\n          .fromTo(cOf(\"47-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"47-no\")[2])}}, 1.7)\n          .fromTo(cOf(\"47-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"47-no\")[3])}}, 1.8)\n          .fromTo(cOf(\"47-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"47-no\")[4])}}, 1.9)\n      }\n\n      function onPageLeave() {\n        pg47Anim.stop();\n        resetNumbers(\"47-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "Trafigura Foundation Annual Report 2023  45  Responding to disasters and crises  Saving lives in the Mediterranean Sea 4  rescue missions carried out by SOS MEDITERRANEE Suisse between November 2022 and March 2023  329  lives saved  Mediterranean Sea Partner: SOS MEDITERRANEE, Suisse The Central Mediterranean between North Africa and Italy is the world’s most dangerous maritime migration route. From June to August 2023 alone, at least 1059 or more than three times more people than the previous year (334), have perished while trying to escape conflict and difficult living conditions in their home country. We provided a donation to SOS MEDITERRANEE Suisse to help cover the rising fuel costs of chartering its vessel Ocean Viking, which, with the help of authorities in charge of rescue at sea, works to save lives at risk in the Mediterranean.  Hurricanes 145,000  Mexico Partner: Mexican Red Cross On 25 October 2023, category-5 hurricane Otis, the strongest-ever recorded to make landfall in the Eastern Pacific, hit the southern coast of Mexico. Devastating Acapulco and other areas of Guerrero state, it left nearly 100 people dead or missing. The Red Cross estimates that over 900,000 people were exposed to the hurricane, and important infrastructure was severely damaged. We funded efforts by the Mexican Red Cross, which distributed humanitarian assistance throughout the region, including food, water, baby kits, hygiene and medical attention, to the communities hit by the hurricane. The Red Cross also helped survivors contact their loved ones by providing access to communication.  Over  382,000 people provided with food  146,000 people received access to fresh water  household and hygiene kits distributed"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 48-title\" style=\"top: 162px;left:100px;\" src=\"/2023/static/_content/48-title-1.png\" />\n      <img class=\"abs halfScale 48-quote\" style=\"top: 572px;left:353px;\" src=\"/2023/static/_content/48-quote-1.png\" />\n\n\n      <h1 id=\"48-no\" class=\"abs euclid-med 48-no\" style=\"top: 687px; left: 73px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 5.7, \"decimals\":1}' ></h1>\n      <h1 id=\"48-no\" class=\"abs euclid-med 48-no\" style=\"top: 682px; left: 240px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 20000, \"comma\":true}' ></h1>\n      <h1 id=\"48-no\" class=\"abs euclid-med 48-no\" style=\"top: 804px; left: 185px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 200, \"preppend\": \"+\"}' ></h1>\n      <h1 id=\"48-no\" class=\"abs euclid-med 48-no\" style=\"top: 788px; left: 513px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 11000, \"preppend\": \"+\",\"comma\": true}' ></h1>\n    ",
    "script": "\n      function onPageEnter() {\n        pg48Anim = new TimelineMax();\n        pg48Anim\n          .staggerFromTo(cOf(\"48-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"48-quote\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.5)\n          .fromTo(cOf(\"48-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"48-no\")[0])}}, 1.7)\n          .fromTo(cOf(\"48-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"48-no\")[1])}}, 1.8)\n          .fromTo(cOf(\"48-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"48-no\")[2])}}, 1.9)\n          .fromTo(cOf(\"48-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"48-no\")[3])}}, 2)\n          .fromTo(cOf(\"48-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"48-no\")[4])}}, 1.9)\n      }\n\n      function onPageLeave() {\n        pg48Anim.stop();\n        resetNumbers(\"48-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "46  Disaster prevention and response  Floods Pakistan  Libya Partner: The International Rescue Committee In September 2023, the extreme rainfall of Storm Daniel led to the collapse of two dams near the coastal city of Derna, causing extreme flooding in Libya where some 800,000 people were already in need of humanitarian assistance before the disaster. More than 5,800 people were killed and more than 44,000 are still displaced, in a region where the effects of climate change and years of conflict and instability are compounding into a complex crisis.  Partner: The Citizens Foundation, TCF In late 2022, an unusually intense monsoon, combined with melting glaciers from a severe heat wave, triggered devastating floods and landslides across one-third of the country. The floods affected about 33 million, or 15 percent of the population, displacing 8 million people and leaving 1.8 million living close to toxic and stagnant floodwater. A severe food crisis followed. Recovery efforts continued well into 2023.  We provided funding to the IRC to help it reach more than 11,000 people affected by the floods, including through the provision of household emergency kits and the deployment of mobile medical teams with mental health and psychosocial specialists, and awareness-raising.  We supported The Citizens Foundation’ efforts through a disaster response grant that enabled them to provide immediate support to over 5,835 families, offer financial assistance to 236 families to rebuild their lives, and rehabilitate six schools.  Overall achievements of TCF under their flood relief efforts  5.7 million  meals delivered as immediate support  20,000  families provided cash relief to rebuild their lives  +200  schools rehabilitated/ rebuilt with better flood resistance  The devastation is immense; people have lost everything and are still in a state of shock. Many are grappling with severe mental distress. The damage is so deep, so severe, that I think it is going to be a long time before Derna can return to its normal state. Majduldeen Alhlafi, IRC Libya Medical Team Leader  +11,000  people provided with first aid"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 49-title\" style=\"top: 161px;left:66px;\" src=\"/2023/static/_content/49-title-1.png\" />\n      <img class=\"abs halfScale 49-quote\" style=\"top: 477px;left:24px;\" src=\"/2023/static/_content/49-quote-1.png\" />\n\n      <h1 id=\"49-no\" class=\"abs euclid-med 49-no\" style=\"top: 782px; left: 371px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 50000, \"comma\":true}' ></h1>\n      <h1 id=\"49-no\" class=\"abs euclid-med 49-no\" style=\"top: 769px; left: 525px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2000, \"preppend\": \"+\",\"comma\": true}' ></h1>\n    ",
    "script": "\n      function onPageEnter() {\n        pg49Anim = new TimelineMax();\n        pg49Anim\n          .staggerFromTo(cOf(\"49-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"49-quote\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.5)\n          .fromTo(cOf(\"49-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[0])}}, 1.7)\n          .fromTo(cOf(\"49-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[1])}}, 1.8)\n          .fromTo(cOf(\"49-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[2])}}, 1.9)\n          .fromTo(cOf(\"49-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[3])}}, 2)\n      }\n\n      function onPageLeave() {\n        pg49Anim.stop();\n        resetNumbers(\"49-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "Trafigura Foundation Annual Report 2023  47  Earthquakes • AKUT and REDOG saved 267 lives. • The Turkish Red Crescent provided over 427 million hot meals, of which the Trafigura Foundation's donation specifically contributed 167,680 meals. • 3.75 million people in Syria have received help from the SARC. 457,000 people received community and protection services. 33,400 families received cash assistance. The Swiss Red Cross works closely with the SARC and has itself purchased and delivered 10,000 hygiene kits to families and 20,000 menstrual hygiene kits to Syrian women and girls.  Turkey and Syria Turkish Red Crescent, REDOG, AKUT, and Swiss Red Cross On 6 February 2023, two major earthquakes shook the Kahramanmaraş region, in southern Turkey near the Syrian border — the most devastating in 20 years. The quake took more than 50,700 lives and caused 1.6 trillion liras in damages. This only exacerbated the complex humanitarian crisis for Syrians undergoing their twelfth year of conflict, as that of the many Syrian refugees in the earthquake area. We fundeda team of rescue dogs and their handlers from REDOG who searched the rubble helping save lives. We also provided financial support to the Turkish Red Crescent for the distribution of meals to the victims, and to the Swiss Red Cross, which supported the earthquake response of the Syrian Arab Red Crescent (SARC). Our grant to AKUT, a Turkish voluntary search and rescue association, allowed it to purchase drones and special rope rescue equipment.  We can help to make life in the emergency shelters a little more bearable. But our support will be needed for a long time to come. The situation of the people who lost everything in the earthquake is still very difficult. Yvonne Rufibach, Project Coordinator for Syria at the SARC  Morocco Partner: Swiss Red Cross On 8 September 2023, a magnitude-6.8 earthquake and its aftershocks killed more than 2,900 people and injured 5,500 in Marrakesh and remote villages in the Atlas Mountains. The damage in the earthquake area was extensive as most local building standards were lax or unenforced. We provided funding to the Swiss Red Cross which deployed specialists to provide emergency care, and coordinate logistics with other humanitarian partners on the ground, providing search and rescue, first aid and psychosocial support.  50,000  people reached with first aid  +2,000  households received essential household items"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 50-title\" style=\"top: 113px;left:50px;\" src=\"/2023/static/_content/50-title-1.png\" />\n        <img class=\"abs halfScale 50-title\" style=\"top: 181px;left:49px;\" src=\"/2023/static/_content/50-text-1.png\" />\n        <img class=\"abs halfScale 50-quote\" style=\"top: 639px;left:84px;\" src=\"/2023/static/_content/50-quote-1.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg50Anim = new TimelineMax();\n          pg50Anim\n            .staggerFromTo(cOf(\"50-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"50-quote\"), 1, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8)\n        }\n\n        function onPageLeave() {\n          pg50Anim.stop();\n          resetNumbers(\"50-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "48  Staff engagement Beyond the workplace, employees united to support the greater good Every year across Trafigura’s global offices, employees are involved in multiple charity initiatives. From volunteering, to fundraising or sponsoring colleagues in a range of sporting events and activities, they actively participate in and positively contribute to the communities in which they work. Part of the Trafigura Foundation’s role is to support these initiatives and harness an inherent spirit of giving back. All the local causes we support are selected by employees themselves, so that we back what really matters to their communities.  Engaging in charitable initiatives is a testament to our company's culture, striving to make a meaningful impact.” Jeremy Weir, Executive Chairman and CEO, Trafigura"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Trafigura Foundation Annual Report 2023  49"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 52-title\" style=\"top: 61px;left:98px;\" src=\"/2023/static/_content/52-title-1.png\" />\n\n      <h1 id=\"52-no\" class=\"abs euclid-med 52-no\" style=\"top: 592px; left: 160px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 872000, \"comma\":true, \"preppend\":\"USD\"}' ></h1>\n    ",
    "script": "\n      function onPageEnter() {\n        pg52Anim = new TimelineMax();\n        pg52Anim\n          .staggerFromTo(cOf(\"52-title\"), 1, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"52-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"52-no\")[0])}}, 1.3)\n      }\n\n      function onPageLeave() {\n        pg52Anim.stop();\n        resetNumbers(\"52-no\");\n        removeContentLinks();\n      }\n    ",
    "searchText": "50  Staff engagement: Beyond the workplace, employees united to support the greater good  When coming together makes a lasting difference  Charity Committees are groups of employees who volunteer to organise charitable activities. They serve as ambassadors of a corporate spirit of philanthropy, translating it into concrete projects developed in collaboration with local charities. To maximise the impact of their generosity and facilitate staff engagement activities, the Trafigura Foundation promotes two special endeavours: • The Charity of the Year: Charity Committees vote for a local charity they would like to support throughout the year. The Foundation provides a 12-month grant to the selected charity, while the Charity Committee ensures that volunteering and fundraising activities involving its office take place effectively throughout the year. • Matching funds: The Trafigura Foundation matches each dollar raised or generated by the direct initiative of a Charity Committee, office, or employee, provided that the funds are designated for a specific charitable purpose validated by the Foundation.  Myriad ways to contribute Last year, Trafigura employees worldwide dedicated countless hours to individual initiatives or through regional Charity Committees. They engaged in activities such as planning, training, running, baking, and volunteering their free time to raise money and support others.  USD872,000  disbursed by the Trafigura Foundation in 2023 to support local charitable projects through the two schemes above  Some notable examples include projects aimed at brightening the lives of underprivileged children in Athens; a marathon in Mumbai to raise funds for a non-profit promoting education and healthy living in India; volunteering efforts to assist low-income households and children in Singapore; a 300-kilometer non-stop rowing journey across the Mediterranean Sea undertaken by Geneva employees to raise awareness on cancer; support for women and their families through educational, labour, and community integration initiatives in Montevideo; various sports events to raise funds for seriously ill children and to combat hunger in Houston; and visits by Shanghai employees to impoverished elderly and visually impaired individuals in rural Chinese areas. Photo: Trafigura Calgary volunteers preparing brown bags for kids."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 53-circle\" style=\"top: 207px;left:496px;\" src=\"/2023/static/_content/53-circle-1.png\" />\n\n        <img class=\"abs halfScale 53-img\" style=\"top: 261px;left:177px;\" src=\"/2023/static/_content/53-img-1.png\" />\n        <img class=\"abs halfScale 53-img\" style=\"top: 469px;left:238px;\" src=\"/2023/static/_content/53-img-2.png\" />\n        <img class=\"abs halfScale 53-img\" style=\"top: 569px;left:238px;\" src=\"/2023/static/_content/53-img-3.png\" />\n        <img class=\"abs halfScale 53-img\" style=\"top: 564px;left:244px;\" src=\"/2023/static/_content/53-img-4.png\" />\n        <img class=\"abs halfScale 53-img\" style=\"top: 217px;left:332px;\" src=\"/2023/static/_content/53-img-5.png\" />\n        <img class=\"abs halfScale 53-img\" style=\"top: 257px;left:342px;\" src=\"/2023/static/_content/53-img-6.png\" />\n        <img class=\"abs halfScale 53-img\" style=\"top: 299px;left:371px;\" src=\"/2023/static/_content/53-img-7.png\" />\n        <img class=\"abs halfScale 53-img\" style=\"top: 552px;left:377px;\" src=\"/2023/static/_content/53-img-8.png\" />\n        <img class=\"abs halfScale 53-img\" style=\"top: 478px;left:450px;\" src=\"/2023/static/_content/53-img-9.png\" />\n        <img class=\"abs halfScale 53-img\" style=\"top: 507px;left:500px;\" src=\"/2023/static/_content/53-img-10.png\" />\n        <img class=\"abs halfScale 53-img\" style=\"top: 457px;left:528px;\" src=\"/2023/static/_content/53-img-11.png\" />\n\n        <h1 id=\"53-no\" class=\"abs euclid-med 53-no\" style=\"top: 234px; left: 544px; font-size: 1.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 11}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg53Anim = new TimelineMax();\n          pg53Anim\n            .staggerFromTo(cOf(\"53-img\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)\n            .fromTo(cOf(\"53-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"53-no\")[0])}}, 1)\n        }\n\n        function onPageLeave() {\n          pg53Anim.stop();\n          resetNumbers(\"53-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "Trafigura Foundation Annual Report 2023  51  London  11  Geneva  Houston  Charity Committees located in major Trafigura offices  Athens  Bahía Blanca  Shanghai  Singapore Montevideo  Mumbai Johannesburg  Campana"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 54-logo\" style=\"top: 48px;left:48px;\" src=\"/2023/static/_content/54-logo-1.png\" />\n\n        <a class=\"addContentLink\" style=\"top: 651px;left: 45px;width: 129px;height: 11px;\" href=\"https://www.trafigurafoundation.org/\" target=\"_blank\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg54Anim = new TimelineMax();\n          pg54Anim\n            .staggerFromTo(cOf(\"54-logo\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)\n            setTimeout(function(){\n              addContentLinks();\n            }, 2000)\n        }\n\n        function onPageLeave() {\n          pg54Anim.stop();\n          resetNumbers(\"54-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "52  Trafigura Foundation 1 Rue de Jargonnant 1207 Geneva Switzerland www.trafigurafoundation.org Copy: Lori Brumat and the Trafigura Foundation Team – Copyediting: Ben Wrobel Design: Charles Cannon – Digitalised version: Touchline Photo credits: Cover: Wilpunt. Inside the report: Media Lens King and raditya (p.4 and 5), SilvaPinto1985 (p.6), Rudi_Suardi (p.7), Chunyip Wong (p.8 and 9), Conexsus Archives (p.10 and 11), ECOTRUST (p.13), Courtesy of TNC (p.14), Nina Saalismaa (p.17), Root Capital (p.18), BOMA/Mercy Mwanzia (p.21), José Cruz/Agência Brasil (p.22), Hadynyah (p.24 and 25), Fundación Don Bosco (p.26), Monica Vallejo (p. 27), REACH (p.28), EFE-Egypt (p.29), Adie (p.30), Germinal (p.31), Word of Mouth (p.32), @ravine_quintans (p.33), SiKanda (p.34), Fondem (p.35), Envision Rwanda (p.36), ©ARM (p.37), ISWAN (p.38), Smart Freight Centre (p.39), International Rescue Committee (p. 40, 41 and 46), Nada (@framesbynad) and ruslan-bardash (p.42), ©Boskalis (p.44), The Citizens Foundation (p.46), Moroccan Red Crescent (p.47), Fotografia Inc (p.48), Alexis David/Venice Ugalde (p.50). This document was printed by Atar Roto Presse SA, Switzerland, on recycled paper certified by the Forest Stewardship Council (FSC® C154575)."
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n\n      function flashContentLinksThreeTimes() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element, duration = 1){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = duration;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function animateNumbers(klass, delay=1, repeat=0.3, duration=1) {\n        setTimeout(function(){\n          for (let i = 0; i < cOf(klass).length; i++) {\n            setTimeout(function() {\n              animateNumber(cOf(klass)[i], duration)\n            }, 1000 * repeat * i)\n          }\n        }, 1000 * delay)\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function individualGallery(index) {\n        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-3R1GJQC4KE" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Om6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4GY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ce36026a7c2023f1782f.js